export default {
  'header.homepage': '返回官网',
  'header.workspace': '工作空间',
  'login.title': 'AIMATEX',
  'login.welcome': '欢迎使用 AIMATEX',
  'login.description': 'AIMATEX 是您的 AI 助手平台，提供图生视频等安全、便捷的创作服务。随时随地，轻松访问您的所有文件。',
  'login.email.placeholder': '邮箱或用户名',
  'login.password.placeholder': '密码',
  'login.button': '登录',
  'login.loading': '登录中...',
  'login.divider': '或使用以下方式登录',
  'login.signup': '还没有账号？',
  'login.signup.link': '立即注册',
  'login.error.default': '登录失败，请稍后重试',
  'login.success': '登录成功',
  'login.forgotPassword': '忘记密码？',
  'login.forgotPassword.link': '点击这里重置',
  'login.rememberPassword': '记住密码',
  'login.social.comingSoon': '该登录方式正在开发中',
  'captcha.placeholder': '人机验证码',
  'captcha.refresh': '刷新验证码',
  'auth.modal.title': '需要登录',
  'auth.modal.content': '您的登录已过期或尚未登录，请登录后继续使用。',
  'auth.modal.ok': '去登录',
  'auth.modal.cancel': '稍后',
  'signup.page.title': '注册 - AIMATEX',
  'signup.title': 'AIMATEX',
  'signup.welcome': '欢迎加入 AIMATEX',
  'signup.description': '创建您的账号，开启 AI 创作之旅',
  'signup.feature.ai': 'AI 驱动',
  'signup.feature.video': '视频创作',
  'signup.feature.fast': '极速生成',
  'signup.feature.creative': '无限创意',
  'signup.username.placeholder': '请输入用户名',
  'signup.email.placeholder': '请输入邮箱',
  'signup.password.placeholder': '请输入密码',
  'signup.confirmPassword.placeholder': '请确认密码',
  'signup.inviteCode.placeholder': '邀请码（选填）',
  'signup.button': '注册',
  'signup.loading': '注册中...',
  'signup.login': '已有账号？',
  'signup.login.link': '立即登录',
  'signup.error.passwordMismatch': '两次输入的密码不一致',
  'signup.error.default': '注册失败，请稍后重试',
  'signup.success': '注册成功',
  'resetPassword.page.title': '重置密码 - AIMATEX',
  'resetPassword.page.description': '重置您的 AIMATEX 账户密码',
  'resetPassword.title': '重置密码',
  'resetPassword.email.placeholder': '请输入邮箱地址',
  'resetPassword.code.placeholder': '请输入验证码',
  'resetPassword.password.placeholder': '请输入新密码',
  'resetPassword.button': '重置密码',
  'resetPassword.button.loading': '重置中...',
  'resetPassword.backToLogin': '返回登录',
  'resetPassword.sendCode': '获取验证码',
  'resetPassword.sendCode.sending': '发送中...',
  'resetPassword.sendCode.retry': '{seconds}秒后重试',
  'resetPassword.error.emailRequired': '请输入邮箱地址',
  'resetPassword.error.codeRequired': '请输入验证码',
  'resetPassword.error.passwordRequired': '请输入新密码',
  'resetPassword.error.passwordLength': '密码长度必须在6-20个字符之间',
  'resetPassword.error.codeLength': '验证码长度必须为6位',
  'resetPassword.success.codeSent': '验证码已发送到您的邮箱',
  'resetPassword.success.reset': '密码重置成功',
  'resetPassword.error.sendFailed': '发送验证码失败，请稍后重试',
  'resetPassword.error.resetFailed': '重置密码失败，请稍后重试',
  'resetPassword.error.incomplete': '请填写完整信息',
  'resetPassword.subtitle': '输入您的邮箱地址和新密码以重置账户访问权限。',
  'resetPassword.email.label': '电子邮箱',
  'resetPassword.code.label': '验证码',
  'resetPassword.password.label': '新密码',
  'resetPassword.success.title': '重置成功',
  'resetPassword.success.description': '您的密码已成功更新，现在可以使用新密码登录了。',
  'resetPassword.goToLogin': '立即登录',
  'resetPassword.promo.title': '保护您的账户，守护您的创意。',
  'resetPassword.promo.description': '我们采用银行级安全协议，确保您的数据和创作专属于您。',
  'signup.username.rule.length': '用户名长度为4-10个字符',
  'signup.username.rule.format': '仅支持字母、数字、下划线和连字符',
  'signup.password.rule.length': '密码长度为6-20个字符',
  'signup.password.rule.lowercase': '包含小写字母',
  'signup.password.rule.uppercase': '包含大写字母',
  'signup.password.rule.number': '包含数字',
  'signup.password.rule.special': '包含特殊字符',
  'signup.verificationCode.placeholder': '请输入验证码',
  'signup.verificationCode.send': '获取验证码',
  'signup.verificationCode.sending': '发送中...',
  'signup.verificationCode.retry': '{seconds}秒后重试',
  'signup.verificationCode.success': '验证码已发送',
  'signup.verificationCode.error': '验证码发送失败',
  'signup.verificationCode.required': '请输入验证码',
  'signup.verificationCode.invalid': '验证码格式不正确',
  'login.verificationCode.placeholder': '请输入验证码',
  'login.verificationCode.send': '获取验证码',
  'login.verificationCode.sending': '发送中...',
  'login.verificationCode.retry': '{seconds}秒后重试',
  'login.verificationCode.success': '验证码已发送',
  'login.verificationCode.error': '验证码发送失败',
  'login.verificationCode.required': '请输入验证码',
  'login.verificationCode.invalid': '验证码格式不正确',
  'signup.error.allFieldsRequired': '请填写所有必填字段',
  'signup.error.emailInvalid': '请输入有效的邮箱地址',
  'signup.error.emailRequired': '请输入邮箱地址',
  'signup.announcement': '注册功能今日维护中！',
  'sidebar.create': '创作',
  'sidebar.allFiles': '全部文件',
  'sidebar.starred': '收藏夹',
  'sidebar.folders': '文件夹',
  'sidebar.trash': '回收站',
  'sidebar.decrypt': '解密工具',
  'sidebar.promptMarket': '提示词商城',
  'sidebar.channels': '生成频道',
  'sidebar.dailyChallenge': '每日挑战',
  'sidebar.mediaTools': '媒体工具',
  'sidebar.storageNodes': '存储节点',
  'sidebar.feedback': '提交需求',
  'sidebar.about': '关于',
  'sidebar.productLog': '产品日志',
  'promptMarket.title': 'Prompt Market',
  'promptMarket.subtitle': '探索顶级创作者的 AI 灵感配方，释放无限创意潜能',
  'promptMarket.searchPlaceholder': '搜索 Prompt、风格、模型...',
  'promptMarket.search': '搜索',
  'promptMarket.all': '全部',
  'promptMarket.tabAll': '全部推荐',
  'promptMarket.tabImage': '文生图',
  'promptMarket.tabVideo': '文生视频',
  'promptMarket.tabAudio': '文生音乐',
  'promptMarket.sortLatest': '最新上架',
  'promptMarket.sortHot': '热门收藏',
  'promptMarket.sortSales': '销量榜',
  'promptMarket.publish': '发布作品',
  'promptMarket.empty': '暂无相关商品，快来发布第一个吧！',
  'promptMarket.free': '免费',
  'promptMarket.token': 'TOKEN',
  'promptMarket.loadFailed': '加载失败',
  'promptMarket.listSuccess': '上架成功',
  'promptMarket.listFailed': '上架失败',
  'create.tab.textToImage': '文生图',
  'create.tab.textToVideo': '文生视频',
  'create.tab.imageToImage': '图生图',
  'create.tab.imageToVideo': '图生视频',
  'create.tab.seedanceVideo': 'Seedance 图生视频',
  'create.seedance.title': 'Seedance 图生视频',
  'create.seedance.subtitle': '字节豆包 Seedance 1.5，图片驱动短视频生成',
  'create.seedance.noModel': '暂无可用的 Seedance 模型，请先在后台配置',
  'create.seedance.cameraFixed': '镜头固定',
  'create.seedance.cameraFixed.true': '是（固定）',
  'create.seedance.cameraFixed.false': '否（动态）',
  'create.seedance.watermark': '添加水印',
  'create.seedance.watermark.true': '是',
  'create.seedance.watermark.false': '否',
  'create.textToImage.title': '文生图',
  'create.textToImage.subtitle': '输入描述，让 AI 绘制您想象中的画面',
  'create.textToImage.description': '通过输入文本描述，生成对应的图片。此功能正在开发中...',
  'create.textToVideo.title': '文生视频',
  'create.textToVideo.subtitle': '输入场景描述与镜头控制，生成高品质视频',
  'create.textToVideo.description': '通过输入文本描述，生成对应的视频。此功能正在开发中...',
  'create.imageToImage.title': '图生图',
  'create.imageToImage.description': '通过上传参考图片，生成新的图片。此功能正在开发中...',
  'create.imageToVideo.title': '图生视频',
  'create.imageToVideo.description': '通过上传参考图片，生成对应的视频。此功能正在开发中...',
  'filelist.column.name': '名称',
  'filelist.column.size': '大小',
  'filelist.column.updateTime': '修改时间',
  'filelist.column.recycletime': '回收时间',
  'filelist.column.actions': '操作',
  'filelist.total': '共 {total} 项',
  'filelist.action.upload': '上传文件',
  'filelist.action.newFolder': '新建文件夹',
  'filelist.action.refresh': '刷新',
  'filelist.action.search': '搜索文件',
  'filelist.action.batchDownload': '批量下载',
  'filelist.action.batchDelete': '批量删除',
  'filelist.action.download': '下载',
  'filelist.action.preview': '预览',
  'filelist.action.rename': '重命名',
  'filelist.selected': '已选择 {count} 项',
  'page.cloudDrive.title': '我的云盘',
  'page.cloudDrive.description': 'AI2OBJ 云盘 - 使用 AI 技术生成高质量 3D 模型',
  'modal.newFolder.title': '新建文件夹',
  'modal.newFolder.placeholder': '请输入文件夹名称',
  
  // 文件上传模态框
  'modal.fileUpload.title': '上传文件',
  'modal.fileUpload.dragText': '将文件拖到此处，或点击上传',
  'modal.fileUpload.start': '开始上传',
  'modal.fileUpload.cancel': '取消',
  'modal.fileUpload.clear': '清空列表',
  'modal.fileUpload.encrypt': '加密选中文件',
  'modal.fileUpload.addMore': '添加更多文件',
  'modal.fileUpload.remove': '移除',
  'modal.fileUpload.error.noSelection': '请选择要移除的文件',
  'modal.fileUpload.error.noEncryption': '请选择要加密的文件',
  'modal.fileUpload.error.noClear': '没有可清空的文件',
  'modal.fileUpload.error.noStart': '没有可上传的文件',
  'modal.fileUpload.error.noCancel': '没有正在上传的文件',
  'modal.fileUpload.error.fileSize': '文件大小超出限制',
  'modal.fileUpload.error.fileType': '不支持的文件类型',
  'modal.fileUpload.error.maxCount': '超出最大文件数量限制',
  'modal.fileUpload.duplicate.title': '文件已存在',
  'modal.fileUpload.duplicate.skip': '跳过',
  'modal.fileUpload.duplicate.replace': '替换',
  'modal.fileUpload.duplicate.rename': '重命名',
  'modal.fileUpload.status.pending': '等待上传',
  'modal.fileUpload.status.uploading': '上传中',
  'modal.fileUpload.status.success': '上传成功',
  'modal.fileUpload.status.error': '上传失败',
  'modal.fileUpload.status.cancelled': '已取消',
  'modal.fileUpload.status.duplicated': '文件重复',
  'modal.fileUpload.table.filename': '文件名',
  'modal.fileUpload.table.size': '大小',
  'modal.fileUpload.table.status': '状态',
  'modal.fileUpload.table.progress': '进度',
  'modal.fileUpload.table.actions': '操作',
  'modal.fileUpload.speed': '上传速度',
  'modal.fileUpload.remainingTime': '剩余时间',
  'modal.fileUpload.total.progress': '总进度',
  'modal.fileUpload.error.message': '上传失败: {message}',
  'modal.fileUpload.confirm.clear': '确定要清空上传列表吗？',
  'modal.fileUpload.confirm.cancel': '确定要取消上传吗？',
  'modal.fileUpload.clear.mobile': '清空',
  'modal.fileUpload.encrypt.mobile': '加密',
  'modal.fileUpload.addMore.mobile': '添加',
  'productLog.title': '产品更新日志',
  
  // 解密页面
  'page.decrypt.title': 'AI2OBJ 文件解密工具',
  'page.decrypt.subtitle': '安全、快速、无损地解密您的文件',
  'page.decrypt.helmet.title': '文件解密工具 - AI2OBJ',
  'page.decrypt.helmet.description': '安全的文件解密工具 - 在浏览器中本地解密您的文件，保护您的隐私',
  
  // 文件上传区域
  'decrypt.upload.dragText': '点击或拖拽文件',
  'decrypt.upload.hint': '支持批量添加 .encrypted 文件，单个文件最大 {maxSize}',
  'decrypt.upload.button.decrypt': '解密选中文件',
  'decrypt.upload.button.clear': '清空列表',
  
  // 文件列表
  'decrypt.fileList.empty': '暂无文件，请添加需要解密的文件',
  'decrypt.fileList.column.name': '文件名',
  'decrypt.fileList.column.size': '大小',
  'decrypt.fileList.column.status': '状态',
  'decrypt.fileList.column.actions': '操作',
  'decrypt.fileList.status.pending': '等待解密',
  'decrypt.fileList.status.decrypting': '解密中',
  'decrypt.fileList.status.success': '解密成功',
  'decrypt.fileList.status.error': '解密失败',
  'decrypt.fileList.action.info': '文件信息',
  
  // 密码弹窗
  'decrypt.password.modal.title': '输入解密密码',
  'decrypt.password.modal.placeholder': '请输入解密密码',
  'decrypt.password.modal.hint': '请输入加密时设置的密码，密码将仅用于本地解密',
  
  // 安全提示弹窗
  'decrypt.security.modal.title': '安全提示',
  'decrypt.security.modal.description': '所有解密操作均在本地完成，您的密码和文件内容不会上传到服务器',
  'decrypt.security.modal.vip.title': '尊敬的会员用户，您可以：',
  'decrypt.security.modal.vip.feature1': '解密任意大小的文件',
  'decrypt.security.modal.vip.feature2': '使用智能分块解密功能，更高效且节省内存',
  'decrypt.security.modal.vip.feature3': '支持批量解密多个大文件',
  'decrypt.security.modal.free.title': '重要提示：解密过程需要在浏览器内存中进行，实际内存占用约为文件大小的3倍。',
  'decrypt.security.modal.free.feature1': '非会员用户单个文件大小限制为4GB',
  'decrypt.security.modal.free.feature2': '开通会员后可解密任意大小文件，并支持分块解密',
  'decrypt.security.modal.free.feature3': '如果出现浏览器崩溃，建议开通会员使用分块解密功能',
  
  // 文件信息弹窗
  'decrypt.fileInfo.modal.title': '文件信息',
  'decrypt.fileInfo.modal.close': '关闭',
  'decrypt.fileInfo.name': '文件名',
  'decrypt.fileInfo.size': '文件大小',
  'decrypt.fileInfo.type': '文件类型',
  'decrypt.fileInfo.lastModified': '最后修改',
  'decrypt.fileInfo.status': '状态',
  'decrypt.fileInfo.progress': '进度',
  'decrypt.fileInfo.speed': '速度',
  'decrypt.fileInfo.timeRemaining': '剩余时间',
  'decrypt.fileInfo.timeSpent': '已用时间',
  'decrypt.fileInfo.error': '错误信息',
  
  // 消息提示
  'decrypt.message.invalidFile': '请只选择带有 .encrypted 后缀的加密文件',
  'decrypt.message.duplicate': '文件 "{filename}" 已存在，已自动去重',
  'decrypt.message.oversizeTitle': '文件大小超出限制',
  'decrypt.message.oversizeContent': '以下文件超出非会员解密上限(4GB)：',
  'decrypt.message.oversizeHint': '开通会员后可解密任意大小文件，并支持分块解密功能',
  'decrypt.message.selectFile': '请选择要解密的文件',
  'decrypt.message.enterPassword': '请输入解密密码',
  'decrypt.message.decryptSuccess': '文件 {filename} 已保存到选定位置',
  'decrypt.message.saveCancel': '已取消保存文件 {filename}',
  'decrypt.message.downloadSuccess': '文件 {filename} 已保存到下载目录',
  'decrypt.message.decryptError': '文件 {filename} 解密失败: {error}',
  'decrypt.message.batchError': '批量解密失败，请重试',
  
  // 解密步骤
  'decrypt.steps.title': '解密步骤',
  'decrypt.steps.items': [
    {
      title: '选择加密文件',
      description: '选择使用 AI2OBJ 加密工具加密的 .encrypted 文件，支持拖拽或点击选择'
    },
    {
      title: '输入解密密码',
      description: '输入加密时设置的密码，密码将仅用于本地解密，不会被传输或存储'
    },
    {
      title: '开始解密',
      description: '点击按钮后，系统将使用 AES-256-CBC 算法在本地解密您的文件'
    },
    {
      title: '获取原始文件',
      description: '解密完成后，原始文件将自动下载，解密过程完全无损，保证文件完整性'
    }
  ],

  // 安全特性
  'security.features.title': '安全特性',
  'security.features.localDecryption.title': '本地解密保护',
  'security.features.localDecryption.description': '所有解密操作均在本地浏览器中完成，确保您的文件内容和密码绝不会上传到服务器，为您的数据安全保驾护航',
  'security.features.militaryEncryption.title': '军事级加密算法',
  'security.features.militaryEncryption.description': '采用 AES-256-CBC 加密算法，这是目前最安全的对称加密标准，可以抵御已知的所有攻击方式',
  'security.features.privacyProtection.title': '隐私数据保护',
  'security.features.privacyProtection.description': '严格的隐私保护机制，不保存任何解密密码，不记录文件内容，让您高枕无忧地使用我们的服务',
  'security.features.smartDecryption.title': '智能分块解密',
  'security.features.smartDecryption.description': '采用智能分块解密技术，显著提升解密速度，同时大幅降低内存占用，让解密更快更稳定',
  'security.features.learnMore': '了解更多',

  // 加密图表
  'security.diagram.plaintext.block1': '明文块 1',
  'security.diagram.plaintext.block2': '明文块 2',
  'security.diagram.ciphertext.block1': '密文块 1',
  'security.diagram.ciphertext.block2': '密文块 2',
  'security.diagram.key': '密钥',
  'security.diagram.aes.encryption': 'AES 加密',
  'security.diagram.xor.operation': '异或运算',
  'security.diagram.iv': '初始化向量',

  // AES 模态框
  'security.features.modal.title': 'AES-256-CBC 加密算法详解',
  'security.features.aes.what': '什么是 AES-256-CBC？',
  'security.features.aes.description': 'AES-256-CBC 是高级加密标准（Advanced Encryption Standard）的一种实现方式，其中：',
  'security.features.aes.detail.1': '一种对称加密算法，由美国国家标准与技术研究院（NIST）于2001年确立',
  'security.features.aes.detail.2': '使用256位密钥长度，提供最高级别的安全性',
  'security.features.aes.detail.3': '密码分组链接（Cipher Block Chaining）模式，提供更好的加密安全性',
  'security.features.aes.how': '工作原理',
  'security.features.aes.process': 'AES-256-CBC 的加密过程主要包含以下步骤：',
  'security.features.aes.step1': '将明文数据分割成固定大小的块（128位）',
  'security.features.aes.step2': '生成随机的初始化向量（IV）',
  'security.features.aes.step3': '使用CBC模式将前一个密文块与当前明文块进行XOR运算',
  'security.features.aes.step4': '使用256位密钥对XOR结果进行AES加密',
  'security.features.aes.example': '加密过程示例：',
  'security.features.aes.security': '安全特性',
  'security.features.aes.security.intro': 'AES-256-CBC 提供了多重安全保障：',
  'security.features.aes.security.point1': '256位密钥提供 2^256 种可能的组合，即使使用超级计算机也无法在合理时间内暴力破解',
  'security.features.aes.security.point2': 'CBC模式确保相同的明文块会产生不同的密文块，增加加密的随机性',
  'security.features.aes.security.point3': '初始化向量（IV）的使用确保即使使用相同的密钥，每次加密的结果也都不同',
  'security.features.aes.security.point4': '被广泛应用于军事、金融等高安全性要求的领域',
  'security.features.aes.diagram': 'CBC 模式加密过程动态示意图',
  'security.features.aes.why': '为什么选择 AES-256-CBC？',
  'security.features.aes.why.intro': '我们选择 AES-256-CBC 作为加密标准的原因：',
  'security.features.aes.why.point1': '经过广泛验证的安全性，至今没有实用的攻击方法',
  'security.features.aes.why.point2': '优秀的性能表现，加解密速度快',
  'security.features.aes.why.point3': '硬件加速支持，主流处理器都内置了 AES 指令集',
  'security.features.aes.why.point4': '广泛的工具支持，各种编程语言都有成熟的实现',

  // 分块解密模态框
  'security.features.chunk.title': '智能分块解密技术详解',
  'security.features.chunk.what': '什么是智能分块解密？',
  'security.features.chunk.description': '智能分块解密是一种针对大文件优化的解密技术，它将大文件分割成多个小块进行并行处理，具有以下特点：',
  'security.features.chunk.feature1.title': '动态分块',
  'security.features.chunk.feature1.desc': '根据文件大小和系统内存自动调整分块大小',
  'security.features.chunk.feature2.title': '并行处理',
  'security.features.chunk.feature2.desc': '多个数据块同时解密，充分利用多核CPU',
  'security.features.chunk.feature3.title': '内存优化',
  'security.features.chunk.feature3.desc': '通过流式处理控制内存使用，避免内存溢出',
  'security.features.chunk.feature4.title': '断点续传',
  'security.features.chunk.feature4.desc': '支持解密过程中断后继续，提高容错性',
  'security.features.chunk.how': '工作原理',
  'security.features.chunk.process': '智能分块解密的处理流程如下：',
  'security.features.chunk.step1': '文件预分析：计算最优分块大小和数量',
  'security.features.chunk.step2': '数据分块：将加密文件切分成大小相等的数据块',
  'security.features.chunk.step3': '并行解密：多个数据块同时进行解密操作',
  'security.features.chunk.step4': '流式写入：解密后的数据块按顺序写入目标文件',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': '性能优势',
  'security.features.chunk.performance.intro': '与传统的一次性解密相比，智能分块解密具有显著优势：',
  'security.features.chunk.performance.point1': '内存占用最高降低90%，4GB文件仅需400MB内存',
  'security.features.chunk.performance.point2': '解密速度提升3-5倍，充分利用多核CPU',
  'security.features.chunk.performance.point3': '支持超大文件（>4GB）解密，不受浏览器内存限制',
  'security.features.chunk.performance.point4': '解密过程可视化，精确显示进度和剩余时间',
  'security.features.chunk.usage': '应用场景',
  'security.features.chunk.usage.intro': '智能分块解密特别适用于以下场景：',
  'security.features.chunk.usage.point1': '大型文件（如视频、数据库备份）的解密',
  'security.features.chunk.usage.point2': '内存受限设备（如移动设备）上的解密操作',
  'security.features.chunk.usage.point3': '需要并行处理的批量文件解密',
  'security.features.chunk.usage.point4': '要求实时进度反馈的解密任务',
  'security.features.chunk.diagram': '智能分块解密流程示意图',

  // 解密图表
  'decrypt.diagram.title': '智能分块解密流程',
  'decrypt.diagram.encryptedFile': '加密文件',
  'decrypt.diagram.smartChunking': '智能分块',
  'decrypt.diagram.parallelDecryption': '并行解密',
  'decrypt.diagram.decryptedFile': '解密文件',
  'decrypt.diagram.memoryOptimization': '内存使用优化',
  'decrypt.diagram.memoryUsage': '仅占用约10%内存空间',
  'decrypt.diagram.realTimeFeedback': '实时进度反馈',
  'filelist.modal.rename.title': '重命名',
  'filelist.modal.rename.placeholder': '请输入新的名称',
  'filelist.modal.rename.ok': '确定',
  'filelist.modal.rename.cancel': '取消',
  'common.unknown': '未知',
  'common.philosophy': '技术应是为人民服务',
  'common.speed': '速度',
  'common.timeSpent': '已用时间',
  'common.remaining': '剩余时间',
  'sideMenu.storageInfo.title': '存储空间',
  'sideMenu.storageInfo.usage': '已使用 {used} / 共 {total}',
  'sideMenu.storageStats.title': '存储空间统计',
  'sideMenu.storageStats.overview': '总览',
  'sideMenu.storageStats.totalFiles': '文件总数',
  'sideMenu.storageStats.totalSize': '总容量',
  'sideMenu.storageStats.fileTypes': '文件类型分布',
  'sideMenu.storageStats.providers': '服务提供商',
  'common.default': '默认',
  'common.regionCode': '地域代码',
  'common.nodeType': '节点类型',
  'common.storageUsed': '已用空间',
  'common.storageAvailable': '可用空间',
  'common.storageLimit': '总容量',
  'common.storageUsageDetail': '已用 {used} / 总容量 {total}',
  'common.defaultNode': '默认节点',
  'common.confirm': '确认',
  'common.cancel': '取消',
  'common.latency': '延迟',
  'common.retry': '重试',
  
  // 节点选择
  'cloudDrive.nodeSelect.title': '选择存储节点',
  'cloudDrive.nodeSelect.addNode': '新增存储节点',
  'cloudDrive.nodeSelect.deleteConfirm.title': '确认删除节点',
  'cloudDrive.nodeSelect.deleteConfirm.content': '确定要删除节点 "{nodeName}" 吗？删除后无法恢复！',
  'cloudDrive.nodeSelect.deleteSuccess': '节点删除成功',
  'cloudDrive.nodeSelect.deleteFailed': '删除节点失败',
  
  // 节点创建
  'cloudDrive.nodeCreate.title': '新增存储节点',
  'cloudDrive.nodeCreate.selectProvider': '选择云厂商',
  'cloudDrive.nodeCreate.nodeName': '节点名称',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': '留空将使用默认名称',
  'cloudDrive.nodeCreate.nameMaxLength': '节点名称不能超过50个字符',
  'cloudDrive.nodeCreate.noProviders': '暂无可用云厂商',
  'cloudDrive.nodeCreate.pingLatency': '延迟 {value} ms',
  'cloudDrive.nodeCreate.pingTesting': '延迟测试中...',
  'cloudDrive.nodeCreate.pingFailed': '延迟测试失败',
  'cloudDrive.nodeCreate.pingUnavailable': '暂不支持延迟测试',
  'cloudDrive.nodeCreate.sortByLatency': '按延迟排序',
  'cloudDrive.nodeCreate.selectRegion': '选择地域',
  'cloudDrive.nodeCreate.selectedRegion': '已选地域',
  'cloudDrive.nodeCreate.noRegions': '暂无可用地域',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': '请选择云厂商',
  'cloudDrive.nodeCreate.selectProviderRequired': '请先选择云厂商',
  'cloudDrive.nodeCreate.selectRegionRequired': '请先选择地域',
  'cloudDrive.nodeCreate.loadProvidersFailed': '获取云厂商列表失败',
  'cloudDrive.nodeCreate.loadRegionsFailed': '获取地域列表失败',
  'cloudDrive.nodeCreate.nodeType': '节点类型',
  'cloudDrive.nodeCreate.nodeType.standard': '标准存储',
  'cloudDrive.nodeCreate.nodeType.lowFreq': '低频存储',
  'cloudDrive.nodeCreate.nodeType.archive': '归档存储',
  'cloudDrive.nodeCreate.storageLimit': '存储限制',
  'cloudDrive.nodeCreate.storageLimitRequired': '请输入存储限制',
  'cloudDrive.nodeCreate.storageLimitMin': '存储限制不能小于1GB',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': '请输入存储限制（GB）',
  'cloudDrive.nodeCreate.success': '存储节点创建成功',
  'cloudDrive.nodeCreate.failed': '创建存储节点失败',
  
  // 节点编辑
  'cloudDrive.nodeEdit.title': '编辑节点',
  'cloudDrive.nodeEdit.name': '节点名称',
  'cloudDrive.nodeEdit.nameRequired': '请输入节点名称',
  'cloudDrive.nodeEdit.nameMaxLength': '节点名称不能超过50个字符',
  
  // TextToImage 页面国际化
  'create.prompt': '提示词 (Prompt)',
  'create.prompt.placeholder': '例如：一只在太空中漫步的赛博朋克猫咪，霓虹灯背景，高清细节...',
  'create.prompt.required': '请输入提示词',
  'create.prompt.generate': 'AI 生成提示词',
  'create.prompt.enrich': 'AI 丰富提示词',
  'create.prompt.generate.success': '提示词生成成功！',
  'create.prompt.generate.error': '提示词生成失败，请重试',
  'create.prompt.generate.empty': '未生成提示词，请重试',
  'create.prompt.restore': '恢复',
  'create.prompt.restore.success': '已恢复到原始提示词',
  'create.prompt.restore.tooltip': '恢复到AI生成/丰富之前的提示词',
  'create.negativePrompt': '反向提示词 (Negative)',
  'create.ratio': '画面比例',
  'create.style': '艺术风格',
  'create.batchSize': '生成数量',
  'create.generate': '立即生成',
  'create.negativePrompt.tooltip': '你不希望画面中出现的元素',
  'create.negativePrompt.placeholder': '例如：模糊，低质量，变形的手指...',
  'create.generating': '正在绘制...',
  'create.generating.waiting': 'AI 正在挥洒创意，请稍候...',
  'create.result.title': '生成结果',
  'create.downloadAll': '全部下载',
  'create.aspectRatio.1:1': '1:1 (正方形)',
  'create.aspectRatio.16:9': '16:9 (横向)',
  'create.aspectRatio.9:16': '9:16 (竖向)',
  'create.aspectRatio.21:9': '21:9 (电影)',
  'create.aspectRatio.4:3': '4:3 (经典)',
  'create.style.general': '通用 (General)',
  'create.style.anime': '动漫 (Anime)',
  'create.style.realistic': '写实 (Realistic)',
  'create.style.3d-render': '3D 渲染 (3D Render)',
  'create.style.cyberpunk': '赛博朋克 (Cyberpunk)',
  'create.settings.loadFailed': '获取创作类型设置失败，显示所有选项',
  'create.settings.error': '加载设置失败，显示所有选项',
  'create.noAvailableTabs': '暂无可用的创作类型',
  'create.network.error.title': '网络连接异常',
  'create.network.error.description': '无法加载创作类型配置，请检查网络连接后刷新页面重试',
  'create.network.error.refresh': '刷新页面',
  
  // TextToVideo 页面国际化
  'create.prompt.video': '视频场景描述 (Prompt)',
  'create.prompt.video.placeholder': '例如：一只宇航员狗狗在月球表面跳舞，8K，电影光线，超现实主义。',
  'create.prompt.video.required': '请输入视频场景描述',
  'create.generate.video': '立即生成视频',
  'create.video.ratio': '视频比例',
  'create.video.camera': '镜头运动',
  'create.video.duration': '视频时长 (秒)',
  'create.video.format': '输出格式',
  'create.cameraMotion.none': '无运动 (None)',
  'create.cameraMotion.zoomIn': '向前推 (Zoom In)',
  'create.cameraMotion.dollyOut': '向后拉 (Dolly Out)',
  'create.cameraMotion.panLeft': '向左平移 (Pan Left)',
  'create.cameraMotion.tiltUp': '向上倾斜 (Tilt Up)',
  'create.cameraMotion.orbital': '360° 环绕 (Orbital)',
  'create.negativePrompt.video.placeholder': '例如：水渍，闪烁，低分辨率，人物模糊...',
  'create.sora.thinking': 'Sora 正在构思中...',
  'create.video.analyzing': '正在分析图片和提示词，AI正在创作中...',
  'create.video.info': '时长: {duration}s | 比例: {ratio}',
  'create.video.preview': '视频预览',
  'create.video.result': '最终视频预览',
  'create.video.empty': '生成结果将显示在此处',
  'create.download': '下载视频',
  'create.video.generate.success': '视频生成任务已提交，请稍候查看结果',
  'create.video.generate.failed': '视频生成失败，请重试',
  'create.video.generate.cancel': '取消生成',
  'create.video.generate.cancelled': '已取消视频生成',
  'create.video.generate.cancelled.polling': '已取消任务轮询',
  'create.video.generate.queued': '视频生成任务已提交，正在排队中...',
  'create.video.generate.noUrl': '视频生成完成，但未获取到视频地址',
  'create.video.status.checkFailed': '查询任务状态失败',
  'create.video.generate.processing': '视频生成任务已提交，正在处理中...',
  'create.video.taskQueue': '任务队列',
  'create.video.polling': '正在生成视频，请稍候...',
  'create.video.ratio.invalid': '请选择模型支持的视频比例',
  'create.duration.format': '{duration}s',
  'create.duration.4s': '4s',
  'create.duration.8s': '8s',
  'create.duration.15s': '15s',
  'create.estimated.price': '预估: {price}',
  'create.model.select': '选择模型',
  'create.model.select.image.placeholder': '请选择要使用的图片生成模型',
  'create.model.loading': '加载模型中...',
  'create.model.loadFailed': '加载模型列表失败',
  'create.model.family.select': '选择模型家族',
  'create.model.family.select.placeholder': '请选择模型家族',
  'create.model.family.loadFailed': '加载模型家族列表失败',
  'create.style.select.placeholder': '请选择艺术风格（可选，默认使用家族模型）',
  'create.model.style.loadFailed': '加载风格模型列表失败',
  'create.model.description': '模型描述',
  'create.model.aspectResolution': '比例分辨率',
  'create.model.fps': '帧率',
  'create.model.features': '支持功能',
  'create.model.feature.cameraMotion': '镜头运动',
  'create.model.feature.img2video': '图生视频',
  'create.model.feature.videoEdit': '视频编辑',
  'create.model.price.perSecond': '/秒',
  'create.model.price.perImage': '/张',
  'create.model.detail': '详情',
  'create.image.format': '输出格式',
  'create.history.title': '生成记录',
  'create.history.refresh': '刷新',
  'create.history.empty': '暂无生成记录',
  'create.history.total': '共 {total} 条记录',
  'create.history.status.queued': '排队',
  'create.history.status.processing': '处理中',
  'create.history.status.success': '成功',
  'create.history.status.failed': '失败',
  'create.history.status.timeout': '超时',
  'create.history.failed.noImage': '生成失败',
  'create.history.failed.noVideo': '生成失败',
  'create.history.downloadAll.start': '开始下载 {count} 张图片',
  'create.history.downloadAll.tooltip': '下载全部 {count} 张图片',
  'create.history.download.tooltip': '下载图片',
  'create.history.detail.tooltip': '查看详情',
  'create.history.noPrompt': '暂无提示词',
  'create.history.deleteConfirm.title': '确认删除',
  'create.history.deleteConfirm.content': '确定要删除这个任务吗？删除后将无法恢复。',
  'create.history.deleteSuccess': '删除成功',
  'create.history.deleteFailed': '删除失败',
  'create.taskDetail.title': '任务详情',
  'create.taskDetail.loading': '加载中...',
  'create.taskDetail.loadFailed': '加载任务详情失败',
  'create.taskDetail.noData': '暂无数据',
  'create.taskDetail.basicInfo': '基本信息',
  'create.taskDetail.model': '模型',
  'create.taskDetail.taskType': '任务类型',
  'create.taskDetail.createTime': '创建时间',
  'create.taskDetail.duration': '生成时长',
  'create.taskDetail.prompt': '提示词',
  'create.taskDetail.error': '错误信息',
  'create.taskDetail.outputFiles': '输出文件',
  'create.taskDetail.downloadAll': '全部下载',
  'create.taskDetail.downloadAll.start': '开始下载 {count} 张图片',
  'create.taskDetail.modelInfo': '模型信息',
  'create.taskDetail.defaultResolution': '默认分辨率',
  'create.taskDetail.maxResolution': '最大分辨率',
  'create.taskDetail.aspectRatios': '支持比例',
  'create.taskDetail.formats': '支持格式',
  'create.taskDetail.prompt.copied': '已复制提示词',
  'create.taskDetail.liked': '已点赞',
  'create.taskDetail.like': '点赞',
  'create.taskDetail.collected': '已收藏',
  'create.taskDetail.collect': '收藏',
  'create.taskDetail.linkCopied': '链接已复制',
  'create.taskDetail.share': '分享',
  'create.taskDetail.outputs': '生成结果',
  'create.taskDetail.preview': '预览',
  'create.taskDetail.download': '下载',
  'create.taskDetail.generationFailed': '生成失败',
  'create.taskDetail.generating': '正在生成...',
  'create.taskDetail.promptLabel': '提示词',
  'create.taskDetail.copy': '复制',
  'create.taskDetail.executionStats': '执行统计',
  'create.taskDetail.creditsCost': '积分消耗',
  'create.taskDetail.modelSpecs': '模型规格',
  'create.taskDetail.capabilities': '功能支持',
  'create.taskDetail.supportedRatios': '支持比例',
  'create.taskDetail.dataError': '数据错误',
  'create.taskDetail.more': '更多',
  'create.taskDetail.downloading': '下载中...',
  'create.taskDetail.points': '积分',
  'create.taskDetail.seconds': '秒',
  'create.taskDetail.status.success': '成功',
  'create.taskDetail.status.failed': '失败',
  'create.taskDetail.status.processing': '处理中',
  'create.taskDetail.status.queued': '排队中',
  'create.taskDetail.status.generating': '生成中',
  'create.taskDetail.durationLabel': '耗时',
  'create.taskDetail.taskParams': '任务参数',
  'create.taskDetail.aspectRatio': '画面比例',
  'create.taskDetail.inputType': '输入类型',
  'create.taskDetail.modelCode': '模型代号',
  'create.taskDetail.regenerate': '再次生成',
  'create.taskDetail.feature.developing': '功能开发中',
  'create.taskDetail.result': '生成结果',
  'create.taskDetail.copyPrompt': '复制提示词',
  'create.taskDetail.imageDimensions': '尺寸',
  'create.taskDetail.fileSize': '大小',
  'create.taskDetail.loadingImageInfo': '加载图片信息中...',
  'create.waitingTask.queue': '任务队列',
  'create.waitingTask.empty': '暂无进行中的任务',
  'create.waitingTask.generating': '生成中...',
  'create.waitingTask.queued': '排队中',
  'create.waitingTask.cancel': '取消任务',
  'create.aspectRatio.3:4': '3:4 (竖版经典)',
  // HistorySection 新增国际化
  'create.history.copyPrompt': '复制提示词',
  'create.history.download': '下载',
  'create.history.delete': '删除',
  'create.history.generating': '生成中...',
  'create.history.generationFailed': '生成失败',
  'create.history.noPreview': '无预览',
  // ImageToVideo 新增国际化
  'create.i2v.fileType.error': '请选择图片文件',
  'create.i2v.fileSize.error': '图片文件大小不能超过10MB',
  'create.i2v.imageSize.error': '图片高度至少需要 {minHeight}px，当前图片尺寸为 {width}x{height}px',
  'create.i2v.fileRead.error': '图片读取失败',
  'create.i2v.replaceImage': '更换图片',
  'create.i2v.upload.supportedFormats': '支持 JPG, PNG, WebP, JFIF',
  'create.i2v.upload.required': '请上传参考图片',
  'create.i2v.prompt.required': '请输入视频运动的引导描述',
  'create.i2v.upload': '上传参考图片 (起始帧)',
  'create.i2v.upload.click': '点击或拖拽上传',
  'create.i2v.uploading.image': '正在上传图片到云端...',
  'create.i2v.upload.success': '图片上传成功',
  'create.i2v.upload.failed': '图片上传失败，请重试',
  'create.i2v.original': '原图 (起始帧)',
  'create.i2v.result': '生成对比',
  'create.i2v.empty': '生成结果与原图对比将显示在此处',
  'create.generate.i2v': '开始生成视频',
  'create.prompt.i2v.placeholder': '例如：让图片中的人物开始行走，背景的树叶随风摇摆...',
  'create.prompt.enhance.tooltip': 'AI丰富提示词，让描述更加详细生动',
  'create.prompt.enhance': 'AI丰富',
  'create.prompt.enhance.empty': '请先输入基础提示词',
  'create.prompt.enhance.success': '提示词丰富成功！',
  'create.prompt.enhance.empty.result': '未生成丰富后的提示词，请重试',
  'create.prompt.enhance.error': '提示词丰富失败，请重试',
  'create.prompt.version.history': '版本历史',
  'create.prompt.version.history.tooltip': '查看提示词版本历史',
  // TaskDetailModal 新增国际化
  'create.taskDetail.unnamedTask': '未命名任务',
  'create.taskDetail.prompt.title': 'Prompt / 提示词',
  'create.taskDetail.tokenCost': 'Token消耗',
  'create.taskDetail.publish': '发布到社区',
  'create.taskDetail.selectCover': '选择封面',
  'create.taskDetail.selectChannel': '选择频道',
  'create.taskDetail.selectChallenge': '选择挑战',
  'create.taskDetail.publishSuccess': '发布成功',
  'create.taskDetail.loadChannelsFailed': '加载频道失败',
  'create.taskDetail.loadChallengesFailed': '加载挑战失败',
  'create.taskDetail.publishFailed': '发布失败',
  'create.taskDetail.daysLeft': '还剩 {days} 天',
  // ModelDetailModal 新增国际化
  'create.model.capability.t2v': 'T2V (Text to Video)',
  'create.model.capability.img2video': 'Img2Video',
  'create.model.capability.videoEdit': 'Video Edit',
  'create.model.capability.characterConsistency': 'Character Consistency',
  'create.model.capability.reference': 'Reference',
  'create.model.capability.cameraMotion': 'Camera Motion',
  'create.model.aspectRatios': 'Aspect Ratios',
  'create.model.resolution': 'Resolution',
  'create.model.resolution.default': 'Default',
  'create.model.resolution.max': 'Max',
  'create.model.duration': 'Duration',
  'create.model.formats': 'Formats',
  'create.model.like': 'Like',
  'create.model.liked': '已喜欢',
  'create.model.unliked': '已取消喜欢',
  'create.model.favorite': 'Favorite',
  'create.model.favorited': '已收藏',
  'create.model.unfavorited': '已取消收藏',
  'create.model.share': 'Share',
  'create.model.linkCopied': '链接已复制',
  'create.model.capabilities': 'Capabilities',
  'create.model.free': '免费',
  'create.model.tokenCost.display': '{count} token',
  // Aspect Ratio 国际化
  'create.aspectRatio.portrait': 'Portrait (竖屏)',
  'create.aspectRatio.landscape': 'Landscape (横屏)',
  'create.video.ratio.placeholder': '请选择视频比例',
  'create.video.format.placeholder': '请选择输出格式',
  'create.video.style': '视频风格',
  'create.video.style.tooltip': '选择视频生成风格',
  'create.video.style.placeholder': '请选择视频风格',
  'create.video.quality': '视频质量',
  'create.video.quality.tooltip': '选择视频生成质量',
  'create.video.quality.placeholder': '请选择视频质量',
  'create.duration.select.placeholder': '请选择视频时长',
  'create.model.select.placeholder': '请先选择模型',
  'video.not.supported': '您的浏览器不支持视频播放。',
  // UnderDevelopment 国际化
  'underDevelopment.comingSoon': '即将推出',
  'underDevelopment.title': '功能正在开发中',
  'underDevelopment.subtitle': '我们正在努力开发这个功能，敬请期待！',
  'underDevelopment.backHome': '返回首页',
  'underDevelopment.goBack': '返回上一页',
  // UserMenu 国际化
  'userMenu.email.notBound': '未绑定邮箱',
  'userMenu.status.verified': '已认证',
  'userMenu.status.guest': '游客',
  'userMenu.level': '等级',
  'userMenu.member.vip1': '普通会员',
  'userMenu.member.vip2': '白银会员',
  'userMenu.member.vip3': '黄金会员',
  'userMenu.member.vip4': '钻石会员',
  'userMenu.member.vip5': '至尊会员',
  
  // 会员等级模态框
  'memberLevel.title': '会员等级体系',
  'memberLevel.description': '选择适合您的会员等级，享受更多权益和功能',
  'memberLevel.free': '普通会员',
  'memberLevel.silver': '白银会员',
  'memberLevel.gold': '黄金会员',
  'memberLevel.diamond': '钻石会员',
  'memberLevel.ultimate': '至尊会员',
  'memberLevel.current': '当前等级',
  'memberLevel.currentLevel': '当前等级',
  'memberLevel.upgrade': '立即升级',
  'memberLevel.downgrade': '已解锁',
  'memberLevel.feature.videoMonthly': '每月视频生成',
  'memberLevel.feature.resolution': '视频分辨率',
  'memberLevel.feature.tokens': '赠送Token',
  'memberLevel.feature.queue': '生成队列',
  'memberLevel.feature.storage': '存储空间',
  'memberLevel.feature.imageMonthly': '图片生成',
  'memberLevel.feature.commercial': '商业授权',
  'memberLevel.feature.api': 'API访问',
  'memberLevel.feature.support': '专属客服',
  'memberLevel.feature.custom': '定制服务',
  'userMenu.recharge': '立即充值',
  'userMenu.community': '社区',
  'userMenu.group.account': '账户设置',
  'userMenu.group.assets': '资产与订单',
  'userMenu.group.workspace': '工作台',
  'userMenu.group.support': '支持',
  'userMenu.item.profile': '个人中心',
  'userMenu.item.settings': '系统设置',
  'userMenu.item.security': '安全设置',
  'userMenu.item.privacy': '隐私偏好',
  'userMenu.item.wallet': '我的钱包',
  'userMenu.item.subscription': '订阅管理',
  'userMenu.item.orders': '订单记录',
  'userMenu.item.works': '我的作品',
  'userMenu.item.community': '社区',
  'userMenu.item.notifications': '消息通知',
  'userMenu.item.help': '帮助中心',
  'userMenu.item.invite': '邀请好友',
  'userMenu.item.feedback': '反馈建议',
  'userMenu.item.about': '关于我们',
  'userMenu.logout': '退出登录',
  // Verification 国际化
  'verification.title': '实名认证',
  'verification.subtitle': '请填写真实信息并上传身份证照片，我们将在1-3个工作日内完成审核',
  'verification.back': '返回',
  'verification.back.profile': '返回个人中心',
  'verification.cancel': '取消',
  'verification.submit': '提交认证',
  'verification.submit.success': '提交成功，等待审核',
  'verification.submit.error': '提交失败，请稍后重试',
  'verification.verified.title': '您已完成实名认证',
  'verification.verified.desc': '认证信息：',
  'verification.step.info': '填写信息',
  'verification.step.upload': '上传证件',
  'verification.step.complete': '完成',
  'verification.info.title': '温馨提示',
  'verification.info.desc': '请确保上传的身份证照片清晰可见，信息完整。您的个人信息将被严格保密，仅用于身份验证。',
  'verification.form.realName.label': '真实姓名',
  'verification.form.realName.required': '请输入真实姓名',
  'verification.form.realName.invalid': '姓名格式不正确',
  'verification.form.realName.placeholder': '请输入与身份证一致的真实姓名',
  'verification.form.idType.label': '证件类型',
  'verification.form.idType.required': '请选择证件类型',
  'verification.form.idType.sfz': '身份证',
  'verification.form.idType.nrm': '其他通用证件',
  'verification.form.cardNum.label': '证件号码',
  'verification.form.cardNum.required': '请输入证件号码',
  'verification.form.cardNum.invalid': '身份证号码格式不正确',
  'verification.form.cardNum.placeholder': '请输入18位身份证号码',
  'verification.form.idCardFront.label': '身份证正面',
  'verification.form.idCardBack.label': '身份证反面',
  'verification.upload.required': '请上传身份证正反面照片',
  'verification.upload.sizeLimit': '文件大小不能超过 5MB',
  'verification.upload.front.text': '点击或拖拽上传身份证正面',
  'verification.upload.back.text': '点击或拖拽上传身份证反面',
  'verification.upload.hint': '支持 JPG, PNG 格式，单个文件不超过 5MB',
  'verification.upload.reupload': '重新上传',
  'verification.reviewing.title': '实名认证审核中',
  'verification.reviewing.desc': '您的实名认证资料正在审核中，预计1-3个工作日完成审核',
  'verification.rejected.title': '实名认证未通过',
  'verification.rejected.desc': '您的实名认证未通过审核',
  'verification.rejected.reason': '拒绝原因',
  'verification.resubmit': '重新提交',
  'verification.info.name': '姓名：',
  'verification.info.idType': '证件类型：',
  'verification.info.idNumber': '证件号码：',
  'verification.info.country': '国家/地区：',
  'verification.info.submitTime': '提交时间：',
  'verification.info.verifyTime': '认证时间：',
  'userMenu.status.reviewing': '审核中',
  'userMenu.status.rejected': '未通过',
  // Profile Page 国际化
  'profile.editProfile': '编辑资料',
  'profile.creditScore': '信用分',
  'profile.level': '等级',
  'profile.balance': '余额',
  'profile.tab.basic': '基本信息',
  'profile.tab.account': '账户资产',
  'profile.section.personal': '个人资料',
  'profile.section.contact': '联系方式',
  'profile.section.wallet': 'USDT 钱包',
  'profile.label.username': '用户名',
  'profile.label.realName': '真实姓名',
  'profile.label.accountStatus': '账户状态',
  'profile.label.phone': '手机号码',
  'profile.label.email': '电子邮箱',
  'profile.label.registerTime': '注册时间',
  'profile.label.availableBalance': '可用余额',
  'profile.label.frozenAmount': '冻结金额',
  'profile.value.notVerified': '未认证',
  'profile.value.notBound': '未绑定',
  'profile.value.noAddress': '暂无 TRC20 地址',
  'profile.value.noDescription': '这个人很懒，什么都没写',
  'profile.status.normal': '正常',
  'profile.status.disabled': '已禁用',
  'profile.tooltip.verified': '已实名认证',
  'profile.tooltip.unverified': '去实名认证',
  'profile.banner.construction': '本页面正在建设中...',
  'profile.modal.title': '编辑个人资料',
  'profile.modal.cancel': '取消',
  'profile.modal.save': '保存更改',
  'profile.modal.avatarSection': '头像设置',
  'profile.modal.basicSection': '基本信息',
  'profile.modal.contactSection': '联系方式',
  'profile.modal.changeAvatar': '更换头像',
  'profile.modal.avatarHint': '支持 JPG, PNG 格式，大小不超过 2MB',
  'profile.modal.nickname': '昵称',
  'profile.modal.nicknamePlaceholder': '请输入您的昵称',
  'profile.modal.description': '个人简介',
  'profile.modal.descriptionPlaceholder': '一句话介绍自己...',
  'profile.modal.phone': '手机号',
  'profile.modal.email': '邮箱',
  'profile.message.avatarSizeLimit': '图片大小不能超过 2MB',
  'profile.message.avatarUploadSuccess': '头像上传成功',
  'profile.message.saveSuccess': '保存成功',
  'profile.message.saveFailed': '保存失败',
  'profile.message.uploadAvatarFailed': '头像上传失败',
  'profile.message.operationFailed': '操作失败',
  // Achievement System 国际化
  'achievement.category.all': '全部',
  'achievement.category.basic': '基础',
  'achievement.category.creation': '创作',
  'achievement.category.payment': '充值',
  'achievement.category.membership': '会员',
  'achievement.category.level': '等级',
  'achievement.category.social': '社交',
  'achievement.category.works': '作品',
  'achievement.level.current': '当前等级：{level}',
  'achievement.stats.unlocked': '已解锁',
  'achievement.stats.locked': '未解锁',
  'achievement.stats.progress': '完成度',
  'achievement.stats.exp': '当前经验',
  // Recharge Agreement 国际化
  'rechargeAgreement.back': '返回',
  'rechargeAgreement.title': '充值服务协议',
  'rechargeAgreement.lastUpdated': '最后更新：',
  'rechargeAgreement.goRecharge': '前往充值',
  'rechargeAgreement.section1.title': '一、协议范围',
  'rechargeAgreement.section1.content1': '本协议是您与平台之间关于充值服务的法律协议。在使用充值服务前，请您仔细阅读本协议的全部内容。如您不同意本协议的任何内容，或者无法准确理解相关条款的含义，请不要进行充值操作。',
  'rechargeAgreement.section1.content2': '当您点击"同意"或进行充值操作时，即表示您已充分阅读、理解并同意接受本协议的全部内容。',
  'rechargeAgreement.section2.title': '二、充值说明',
  'rechargeAgreement.section2.subtitle1': '2.1 充值方式',
  'rechargeAgreement.section2.content1': '平台支持以下充值方式：',
  'rechargeAgreement.section2.method1': '支付宝支付',
  'rechargeAgreement.section2.method2': '微信支付',
  'rechargeAgreement.section2.method3': '银行卡支付（银联、Visa、MasterCard）',
  'rechargeAgreement.section2.method4': 'USDT 加密货币支付（ERC20/TRC20）',
  'rechargeAgreement.section2.subtitle2': '2.2 充值币种',
  'rechargeAgreement.section2.content2': '平台支持以下币种充值：人民币（CNY）、美元（USD）、USDT。不同币种之间可能存在汇率转换，具体汇率以充值时的实时汇率为准。',
  'rechargeAgreement.section2.subtitle3': '2.3 充值限额',
  'rechargeAgreement.section2.limit1': '单次最低充值金额：1 元（或等值其他币种）',
  'rechargeAgreement.section2.limit2': '单次最高充值金额：50,000 元（或等值其他币种）',
  'rechargeAgreement.section2.limit3': '每日累计充值限额：100,000 元（或等值其他币种）',
  'rechargeAgreement.section2.note': '注意：充值限额可能因支付方式、账户等级等因素而有所不同，具体以充值页面显示为准。',
  'rechargeAgreement.section3.title': '三、充值到账',
  'rechargeAgreement.section3.subtitle1': '3.1 到账时间',
  'rechargeAgreement.section3.time1': '支付宝、微信支付：实时到账',
  'rechargeAgreement.section3.time2': '银行卡支付：1-3 个工作日到账',
  'rechargeAgreement.section3.time3': 'USDT 支付：根据区块链确认时间，通常 10-30 分钟到账',
  'rechargeAgreement.section3.subtitle2': '3.2 异常处理',
  'rechargeAgreement.section3.content1': '如充值后未及时到账，请保留支付凭证，并及时联系客服处理。平台将在核实后尽快处理您的充值问题。',
  'rechargeAgreement.section4.title': '四、退款政策',
  'rechargeAgreement.section4.important': '重要提示：充值成功后，账户余额不支持直接退款。余额仅可用于平台内服务消费。',
  'rechargeAgreement.section4.subtitle1': '4.1 退款条件',
  'rechargeAgreement.section4.content1': '在以下情况下，您可以申请退款：',
  'rechargeAgreement.section4.refund1': '因平台系统故障导致重复充值',
  'rechargeAgreement.section4.refund2': '因平台原因导致服务无法正常使用，且账户余额未消费',
  'rechargeAgreement.section4.refund3': '其他经平台审核同意的特殊情况',
  'rechargeAgreement.section4.subtitle2': '4.2 退款流程',
  'rechargeAgreement.section4.process1': '提交退款申请，说明退款原因',
  'rechargeAgreement.section4.process2': '平台审核（通常 3-7 个工作日）',
  'rechargeAgreement.section4.process3': '审核通过后，退款将原路返回到您的支付账户',
  'rechargeAgreement.section5.title': '五、账户安全',
  'rechargeAgreement.section5.content1': '您有责任妥善保管账户信息及密码，因您自身原因导致账户被盗用或密码泄露造成的损失，平台不承担责任。',
  'rechargeAgreement.section5.content2': '如发现账户异常，请立即联系客服并修改密码。平台将协助您处理相关问题。',
  'rechargeAgreement.section6.title': '六、免责声明',
  'rechargeAgreement.section6.disclaimer1': '因不可抗力（如自然灾害、战争、政府行为等）导致的服务中断，平台不承担责任',
  'rechargeAgreement.section6.disclaimer2': '因第三方支付平台故障导致的充值问题，平台将协助处理，但不承担直接责任',
  'rechargeAgreement.section6.disclaimer3': '因用户违反本协议或相关法律法规导致的损失，由用户自行承担',
  'rechargeAgreement.section7.title': '七、协议修改',
  'rechargeAgreement.section7.content1': '平台有权根据业务发展需要修改本协议。协议修改后，将在平台显著位置公示。如您继续使用充值服务，视为接受修改后的协议。',
  'rechargeAgreement.section8.title': '八、联系方式',
  'rechargeAgreement.section8.content1': '如您对本协议有任何疑问，或需要申请退款、处理充值问题，请通过以下方式联系我们：',
  'rechargeAgreement.section8.contact1': '客服邮箱：support@example.com',
  'rechargeAgreement.section8.contact2': '在线客服：工作日 9:00-18:00',
  'rechargeAgreement.section8.contact3': '帮助中心：查看常见问题',
  'privacyPreferences.title': '隐私偏好设置',
  'privacyPreferences.description': '管理您的隐私设置，控制我们如何收集和使用您的数据',
  'privacyPreferences.back': '返回',
  'privacyPreferences.save': '保存设置',
  'privacyPreferences.saveSuccess': '隐私偏好设置已保存',
  'privacyPreferences.saveError': '保存失败，请稍后重试',
  'privacyPreferences.required': '必需',
  'privacyPreferences.info': '您的隐私偏好设置将保存在本地，并会在您下次访问时自动应用。登录后可将设置同步到云端。',
  'privacyPreferences.info.loggedIn': '您的隐私偏好设置将保存到您的账户中，并在所有设备上同步。您随时可以返回此页面修改这些设置。',
  'cookieBanner.message': '我们使用 Cookie 和本地存储以提供登录、主题与基础功能。继续使用即表示您同意我们按隐私政策使用这些技术。',
  'cookieBanner.acceptAll': '全部接受',
  'cookieBanner.essentialOnly': '仅必需',
  'cookieBanner.settings': '偏好设置',
  'privacyPreferences.cookies.title': 'Cookie 偏好',
  'privacyPreferences.cookies.description': 'Cookie 帮助我们提供更好的服务体验。您可以选择接受或拒绝某些类型的 Cookie。',
  'privacyPreferences.cookies.essential': '必需 Cookie',
  'privacyPreferences.cookies.essential.desc': '这些 Cookie 是网站正常运行所必需的，无法关闭。它们通常用于安全、登录和基本功能。',
  'privacyPreferences.cookies.functional': '功能 Cookie',
  'privacyPreferences.cookies.functional.desc': '这些 Cookie 允许网站记住您的选择，提供增强的功能和个性化体验。',
  'privacyPreferences.cookies.analytics': '分析 Cookie',
  'privacyPreferences.cookies.analytics.desc': '这些 Cookie 帮助我们了解访问者如何使用网站，以便我们改进服务。',
  'privacyPreferences.cookies.marketing': '营销 Cookie',
  'privacyPreferences.cookies.marketing.desc': '这些 Cookie 用于跟踪您的浏览活动，以便向您展示相关广告和内容。',
  'privacyPreferences.data.title': '数据收集偏好',
  'privacyPreferences.data.description': '控制我们如何收集和使用您的数据来改善服务体验。',
  'privacyPreferences.data.collection': '数据收集',
  'privacyPreferences.data.collection.desc': '允许我们收集必要的使用数据以提供和改进服务。',
  'privacyPreferences.data.analytics': '数据分析',
  'privacyPreferences.data.analytics.desc': '允许我们分析您的使用模式以优化服务性能和用户体验。',
  'privacyPreferences.data.personalization': '个性化推荐',
  'privacyPreferences.data.personalization.desc': '允许我们根据您的偏好和使用习惯提供个性化内容和推荐。',
  'privacyPreferences.marketing.title': '营销偏好',
  'privacyPreferences.marketing.description': '选择您希望接收的营销信息类型。',
  'privacyPreferences.marketing.emails': '营销邮件',
  'privacyPreferences.marketing.emails.desc': '接收产品更新、促销活动和特别优惠的邮件通知。',
  'privacyPreferences.marketing.sms': '营销短信',
  'privacyPreferences.marketing.sms.desc': '接收重要更新和促销活动的短信通知。',
  'privacyPreferences.marketing.push': '推送通知',
  'privacyPreferences.marketing.push.desc': '接收浏览器推送通知，包括产品更新和重要消息。',
  'privacyPreferences.thirdParty.title': '第三方数据共享',
  'privacyPreferences.thirdParty.description': '控制是否允许与第三方服务提供商共享您的数据。',
  'privacyPreferences.thirdParty.sharing': '第三方数据共享',
  'privacyPreferences.thirdParty.sharing.desc': '允许我们与可信的第三方服务提供商共享匿名化的使用数据，以改善服务。',
  'works.title': '我的作品',
  'works.description': '管理和查看您生成的所有作品',
  'works.refresh': '刷新',
  'works.stats.total': '全部作品',
  'works.stats.images': '图片',
  'works.stats.videos': '视频',
  'works.stats.audios': '音频',
  'works.stats.favorites': '收藏',
  'works.search.placeholder': '搜索作品...',
  'works.filter.all': '全部类型',
  'works.filter.image': '图片',
  'works.filter.video': '视频',
  'works.filter.audio': '音频',
  'works.date.start': '开始日期',
  'works.date.end': '结束日期',
  'works.sort.date': '按日期',
  'works.sort.name': '按名称',
  'works.sort.size': '按大小',
  'works.sort.asc': '升序',
  'works.sort.desc': '降序',
  'works.view.grid': '网格',
  'works.view.list': '列表',
  'works.type.video': '视频',
  'works.type.image': '图片',
  'works.type.audio': '音频',
  'works.preview': '预览',
  'works.download': '下载',
  'works.share': '分享',
  'works.delete': '删除',
  'works.deleteConfirm': '确定要删除这个作品吗？',
  'works.loadError': '加载作品失败，请稍后重试',
  'works.favoriteUpdated': '收藏状态已更新',
  'works.favoriteError': '更新收藏失败',
  'works.downloading': '正在下载...',
  'works.sharing': '正在生成分享链接...',
  'works.deleted': '作品已删除',
  'works.deleteError': '删除失败，请稍后重试',
  'works.empty.title': '暂无作品',
  'works.empty.description': '开始创建您的第一个作品吧！',
  'works.empty.action': '去创作',
  'works.pagination.total': '共 {total} 项，显示第 {start}-{end} 项',
  
  // 隐私政策
  'privacyPolicy.title': '隐私政策',
  'privacyPolicy.lastUpdated': '最后更新日期：{date}',
  'privacyPolicy.intro1': '本隐私政策描述了 AIMATEX 平台（以下简称"我们"或"本平台"）在您使用我们的服务时如何收集、使用、存储和保护您的个人信息，以及您的隐私权利。我们非常重视您的隐私保护，请仔细阅读本隐私政策。',
  'privacyPolicy.intro2': '使用我们的服务即表示您同意本隐私政策。如果您不同意本隐私政策的任何内容，请不要使用我们的服务。',
  'privacyPolicy.section1.title': '一、我们收集的信息',
  'privacyPolicy.section1.1.title': '1.1 您主动提供的信息',
  'privacyPolicy.section1.1.intro': '在使用本服务时，您可能需要提供以下信息：',
  'privacyPolicy.section1.1.item1.label': '账户信息',
  'privacyPolicy.section1.1.item1.desc': '用户名、邮箱地址、密码、手机号码等',
  'privacyPolicy.section1.1.item2.label': '个人资料',
  'privacyPolicy.section1.1.item2.desc': '头像、昵称、个人简介等（可选）',
  'privacyPolicy.section1.1.item3.label': '支付信息',
  'privacyPolicy.section1.1.item3.desc': '支付方式、账单地址等（用于处理支付）',
  'privacyPolicy.section1.1.item4.label': '生成内容',
  'privacyPolicy.section1.1.item4.desc': '您上传的文本提示词、参考图片、生成的视频、音乐、图像、3D 模型等',
  'privacyPolicy.section1.2.title': '1.2 自动收集的信息',
  'privacyPolicy.section1.2.intro': '当您使用本服务时，我们可能自动收集以下信息：',
  'privacyPolicy.section1.2.item1.label': '设备信息',
  'privacyPolicy.section1.2.item1.desc': '设备类型、操作系统、浏览器类型和版本、设备标识符等',
  'privacyPolicy.section1.2.item2.label': '使用数据',
  'privacyPolicy.section1.2.item2.desc': '访问时间、访问页面、使用功能、操作记录等',
  'privacyPolicy.section1.2.item3.label': '网络信息',
  'privacyPolicy.section1.2.item3.desc': 'IP 地址、网络类型、网络运营商等',
  'privacyPolicy.section1.2.item4.label': '日志信息',
  'privacyPolicy.section1.2.item4.desc': '错误日志、性能数据等',
  'privacyPolicy.section1.3.title': '1.3 Cookie 和类似技术',
  'privacyPolicy.section1.3.intro': '我们使用 Cookie 和类似技术来：',
  'privacyPolicy.section1.3.item1': '保持您的登录状态',
  'privacyPolicy.section1.3.item2': '记住您的偏好设置（如语言、主题等）',
  'privacyPolicy.section1.3.item3': '分析服务使用情况，改进服务质量',
  'privacyPolicy.section1.3.item4': '提供个性化体验',
  'privacyPolicy.section1.3.note': '您可以通过浏览器设置拒绝 Cookie，但这可能影响部分功能的使用。',
  'privacyPolicy.section2.title': '二、信息的使用目的',
  'privacyPolicy.section2.intro': '我们收集和使用您的信息用于以下目的：',
  'privacyPolicy.section2.item1.label': '提供服务',
  'privacyPolicy.section2.item1.desc': '处理您的内容生成请求（包括视频、音乐、图像、3D 模型等）、管理您的账户和作品等',
  'privacyPolicy.section2.item2.label': '改进服务',
  'privacyPolicy.section2.item2.desc': '分析使用情况，优化服务性能和用户体验',
  'privacyPolicy.section2.item3.label': '账户管理',
  'privacyPolicy.section2.item3.desc': '验证身份、处理支付、发送通知等',
  'privacyPolicy.section2.item4.label': '安全保障',
  'privacyPolicy.section2.item4.desc': '检测和防范欺诈、滥用、安全威胁等',
  'privacyPolicy.section2.item5.label': '客户支持',
  'privacyPolicy.section2.item5.desc': '响应您的咨询、处理投诉和反馈等',
  'privacyPolicy.section2.item6.label': '法律合规',
  'privacyPolicy.section2.item6.desc': '遵守法律法规要求，配合执法部门调查等',
  'privacyPolicy.section3.title': '三、信息的共享与披露',
  'privacyPolicy.section3.1.title': '3.1 我们不会出售您的个人信息',
  'privacyPolicy.section3.1.content': '我们不会向第三方出售、出租或以其他方式交易您的个人信息。',
  'privacyPolicy.section3.2.title': '3.2 服务提供商',
  'privacyPolicy.section3.2.intro': '我们可能与以下类型的服务提供商共享信息：',
  'privacyPolicy.section3.2.item1.label': '云服务提供商',
  'privacyPolicy.section3.2.item1.desc': '用于存储和处理数据',
  'privacyPolicy.section3.2.item2.label': '支付服务提供商',
  'privacyPolicy.section3.2.item2.desc': '用于处理支付交易',
  'privacyPolicy.section3.2.item3.label': '分析服务提供商',
  'privacyPolicy.section3.2.item3.desc': '用于分析服务使用情况',
  'privacyPolicy.section3.2.item4.label': '客户支持服务提供商',
  'privacyPolicy.section3.2.item4.desc': '用于提供客户支持',
  'privacyPolicy.section3.2.note': '这些服务提供商只能将信息用于向我们提供服务，不得用于其他目的。',
  'privacyPolicy.section3.3.title': '3.3 法律要求',
  'privacyPolicy.section3.3.intro': '在以下情况下，我们可能披露您的信息：',
  'privacyPolicy.section3.3.item1': '遵守法律法规、法院命令或政府要求',
  'privacyPolicy.section3.3.item2': '保护我们的权利、财产或安全',
  'privacyPolicy.section3.3.item3': '防止或调查可能的违法行为',
  'privacyPolicy.section3.3.item4': '保护用户或公众的安全',
  'privacyPolicy.section3.4.title': '3.4 业务转让',
  'privacyPolicy.section3.4.content': '如果发生合并、收购或资产转让，您的信息可能会被转移。我们会在转移前通知您。',
  'privacyPolicy.section4.title': '四、信息的存储与安全',
  'privacyPolicy.section4.1.title': '4.1 存储地点',
  'privacyPolicy.section4.1.content': '您的信息可能存储在位于中华人民共和国境内或境外的服务器上。我们会采取适当措施确保信息的安全。',
  'privacyPolicy.section4.2.title': '4.2 存储期限',
  'privacyPolicy.section4.2.intro': '我们仅在必要期间内保留您的信息：',
  'privacyPolicy.section4.2.item1': '账户信息：在您账户存续期间及注销后的一段时间内',
  'privacyPolicy.section4.2.item2': '生成内容：根据您的设置或法律要求保留',
  'privacyPolicy.section4.2.item3': '使用数据：通常保留较短时间，用于分析和改进服务',
  'privacyPolicy.section4.3.title': '4.3 安全措施',
  'privacyPolicy.section4.3.intro': '我们采取以下安全措施保护您的信息：',
  'privacyPolicy.section4.3.item1': '加密传输和存储',
  'privacyPolicy.section4.3.item2': '访问控制和身份验证',
  'privacyPolicy.section4.3.item3': '定期安全审计和漏洞扫描',
  'privacyPolicy.section4.3.item4': '员工培训和保密协议',
  'privacyPolicy.section4.3.note': '请注意，没有任何安全措施是 100% 安全的。我们无法保证信息的绝对安全。',
  'privacyPolicy.section5.title': '五、您的权利',
  'privacyPolicy.section5.intro': '根据适用的法律法规，您享有以下权利：',
  'privacyPolicy.section5.item1.label': '访问权',
  'privacyPolicy.section5.item1.desc': '查看我们持有的您的个人信息',
  'privacyPolicy.section5.item2.label': '更正权',
  'privacyPolicy.section5.item2.desc': '更正不准确或不完整的信息',
  'privacyPolicy.section5.item3.label': '删除权',
  'privacyPolicy.section5.item3.desc': '要求删除您的个人信息（法律要求保留的除外）',
  'privacyPolicy.section5.item4.label': '撤回同意',
  'privacyPolicy.section5.item4.desc': '撤回您对信息处理的同意',
  'privacyPolicy.section5.item5.label': '数据可携权',
  'privacyPolicy.section5.item5.desc': '获取您的个人信息副本',
  'privacyPolicy.section5.item6.label': '反对权',
  'privacyPolicy.section5.item6.desc': '反对某些信息处理活动',
  'privacyPolicy.section5.note': '如需行使上述权利，请通过本隐私政策末尾的联系方式联系我们。',
  'privacyPolicy.section6.title': '六、未成年人保护',
  'privacyPolicy.section6.content1': '本服务主要面向 18 周岁以上的用户。如果您未满 18 周岁，请在监护人同意和指导下使用本服务。',
  'privacyPolicy.section6.content2': '如果我们发现收集了未满 18 周岁用户的个人信息，且未获得监护人同意，我们会尽快删除相关信息。',
  'privacyPolicy.section7.title': '七、第三方链接',
  'privacyPolicy.section7.content': '本服务可能包含指向第三方网站的链接。我们不对这些第三方网站的隐私做法负责。访问这些网站时，请查看其隐私政策。',
  'privacyPolicy.section8.title': '八、隐私政策的变更',
  'privacyPolicy.section8.content1': '我们可能不时更新本隐私政策。重大变更将在生效前至少 30 天通知您。继续使用服务即表示您接受更新后的隐私政策。',
  'privacyPolicy.section8.content2': '我们会在本页面顶部更新"最后更新日期"，并通过邮件或站内通知告知您重要变更。',
  'privacyPolicy.section9.title': '九、联系我们',
  'privacyPolicy.section9.intro': '如您对本隐私政策有任何疑问、意见或投诉，请通过以下方式联系我们：',
  'privacyPolicy.section9.email': '邮箱：{email}',
  'privacyPolicy.section9.hours': '客服时间：工作日 9:00-18:00',
  'privacyPolicy.section9.response': '我们会在合理时间内回复您的请求。',
  
  // 服务条款
  'termsOfService.title': '服务条款',
  'termsOfService.lastUpdated': '最后更新日期：{date}',
  'termsOfService.intro': '在使用我们的服务之前，请仔细阅读本服务条款。通过访问或使用 AIMATEX 平台（以下简称"本平台"或"服务"），您同意受本服务条款的约束。如果您不同意本服务条款的任何部分，请不要使用我们的服务。',
  'termsOfService.section1.title': '一、定义与解释',
  'termsOfService.section1.1.title': '1.1 定义',
  'termsOfService.section1.1.intro': '在本服务条款中，除非上下文另有说明，下列术语具有以下含义：',
  'termsOfService.section1.1.item1.label': '"平台"或"本平台"',
  'termsOfService.section1.1.item1.desc': '指 AIMATEX 综合 AI 创作平台，包括但不限于网站、移动应用及相关服务。',
  'termsOfService.section1.1.item2.label': '"我们"、"我方"、"公司"',
  'termsOfService.section1.1.item2.desc': '指 AIMATEX 平台的运营方，即 ProTX Team。',
  'termsOfService.section1.1.item3.label': '"您"、"用户"',
  'termsOfService.section1.1.item3.desc': '指访问或使用本服务的个人、公司或其他法律实体。',
  'termsOfService.section1.1.item4.label': '"服务"',
  'termsOfService.section1.1.item4.desc': '指本平台提供的所有功能和服务，包括但不限于 AI 视频、音乐、图像、3D 模型等各类内容生成、模型选择、作品管理、用户账户管理等。',
  'termsOfService.section1.1.item5.label': '"内容"',
  'termsOfService.section1.1.item5.desc': '指用户通过本平台上传、生成、创建或分享的任何文本、图片、视频、音乐、3D 模型等材料。',
  'termsOfService.section1.1.item6.label': '"生成内容"',
  'termsOfService.section1.1.item6.desc': '指用户使用本平台的 AI 模型生成的视频、音乐、图像、3D 模型等各类作品。',
  'termsOfService.section1.1.item7.label': '"账户"',
  'termsOfService.section1.1.item7.desc': '指用户在本平台注册的用户账户。',
  'termsOfService.section2.title': '二、服务说明',
  'termsOfService.section2.1.title': '2.1 服务内容',
  'termsOfService.section2.1.intro': '本平台提供基于 AI 技术的综合内容生成服务，包括但不限于：',
  'termsOfService.section2.1.item1': '文本生成视频、音乐、图像、3D 模型等（Text-to-Media）',
  'termsOfService.section2.1.item2': '图片生成视频、3D 模型等（Image-to-Media）',
  'termsOfService.section2.1.item3': '各类生成作品的管理和展示',
  'termsOfService.section2.1.item4': '模型选择和管理',
  'termsOfService.section2.1.item5': '用户账户和个人中心',
  'termsOfService.section2.1.item6': '订阅和支付服务',
  'termsOfService.section2.2.title': '2.2 服务变更',
  'termsOfService.section2.2.content': '我们保留随时修改、暂停或终止部分或全部服务的权利，无需事先通知。我们不对因服务变更而导致的任何损失承担责任。',
  'termsOfService.section3.title': '三、用户账户',
  'termsOfService.section3.1.title': '3.1 账户注册',
  'termsOfService.section3.1.intro': '使用本服务需要注册账户。注册时，您同意：',
  'termsOfService.section3.1.item1': '提供真实、准确、完整的注册信息',
  'termsOfService.section3.1.item2': '及时更新注册信息，保持其真实、准确、完整',
  'termsOfService.section3.1.item3': '对账户下的所有活动负责',
  'termsOfService.section3.1.item4': '妥善保管账户密码，不得将账户转让、出售或出借给他人',
  'termsOfService.section3.2.title': '3.2 年龄限制',
  'termsOfService.section3.2.content': '您必须年满 18 周岁才能使用本服务。如果您未满 18 周岁，请在监护人同意和指导下使用本服务。',
  'termsOfService.section3.3.title': '3.3 账户安全',
  'termsOfService.section3.3.content': '您有责任维护账户的安全。如发现账户被盗用或存在安全漏洞，请立即通知我们。我们不对因您未妥善保管账户信息而导致的损失承担责任。',
  'termsOfService.section4.title': '四、使用规范',
  'termsOfService.section4.1.title': '4.1 禁止行为',
  'termsOfService.section4.1.intro': '使用本服务时，您不得：',
  'termsOfService.section4.1.item1': '生成、上传、分享任何违法、有害、威胁、辱骂、骚扰、诽谤、粗俗、淫秽、侵犯他人隐私或知识产权的内容',
  'termsOfService.section4.1.item2': '生成、传播任何虚假信息、误导性内容或恶意内容',
  'termsOfService.section4.1.item3': '使用本服务进行任何商业欺诈、洗钱或其他非法活动',
  'termsOfService.section4.1.item4': '干扰或破坏本平台的正常运行，包括但不限于使用自动化工具、爬虫、病毒等',
  'termsOfService.section4.1.item5': '未经授权访问本平台的任何系统、数据或账户',
  'termsOfService.section4.1.item6': '复制、修改、分发、出售或租赁本平台的任何部分',
  'termsOfService.section4.1.item7': '反向工程、反编译或反汇编本平台的任何软件',
  'termsOfService.section4.2.title': '4.2 内容责任',
  'termsOfService.section4.2.content': '您对通过本平台生成、上传、分享的所有内容承担全部责任。我们不对用户生成的内容进行预先审查，但保留随时删除违规内容的权利。',
  'termsOfService.section5.title': '五、知识产权',
  'termsOfService.section5.1.title': '5.1 平台知识产权',
  'termsOfService.section5.1.content': '本平台的所有知识产权，包括但不限于商标、专利、版权、商业秘密等，均归我们或相关权利人所有。未经授权，您不得使用。',
  'termsOfService.section5.2.title': '5.2 用户生成内容',
  'termsOfService.section5.2.content': '您通过本平台生成的内容，其知识产权归您所有。但您授予我们非独占、全球性、免费、可再许可的权利，以使用、展示、分发您的内容，用于提供和改进服务。',
  'termsOfService.section5.3.title': '5.3 AI 模型',
  'termsOfService.section5.3.content': '本平台使用的 AI 模型（包括 Sora 模型）的知识产权归其开发者所有。您不得复制、修改或分发这些模型。',
  'termsOfService.section6.title': '六、付费服务',
  'termsOfService.section6.1.title': '6.1 付费模式',
  'termsOfService.section6.1.content': '本平台提供订阅和按次付费两种模式。具体价格和计费方式以平台公示为准。',
  'termsOfService.section6.2.title': '6.2 支付',
  'termsOfService.section6.2.content': '您同意按照平台公示的价格支付服务费用。所有费用均以人民币或其他平台支持的货币计价。支付成功后，费用不予退还，除非法律另有规定或我们另有承诺。',
  'termsOfService.section6.3.title': '6.3 退款政策',
  'termsOfService.section6.3.content': '除非法律另有规定或我们另有承诺，已支付的费用不予退还。如因平台原因导致服务无法正常使用，我们将根据实际情况提供退款或补偿。',
  'termsOfService.section7.title': '七、服务可用性',
  'termsOfService.section7.1.title': '7.1 服务中断',
  'termsOfService.section7.1.intro': '我们不对因以下原因导致的服务中断承担责任：',
  'termsOfService.section7.1.item1': '系统维护、升级或故障',
  'termsOfService.section7.1.item2': '不可抗力因素（如自然灾害、战争、罢工等）',
  'termsOfService.section7.1.item3': '第三方服务提供商的问题',
  'termsOfService.section7.1.item4': '网络故障或用户设备问题',
  'termsOfService.section7.2.title': '7.2 服务保证',
  'termsOfService.section7.2.content': '我们尽力保证服务的稳定性和可用性，但不保证服务不会中断、无错误或完全安全。服务按"现状"和"可用"的基础提供，不提供任何明示或暗示的保证。',
  'termsOfService.section8.title': '八、隐私保护',
  'termsOfService.section8.content': '我们重视您的隐私保护。关于我们如何收集、使用和保护您的个人信息，请参阅我们的《隐私政策》。使用本服务即表示您同意我们的隐私政策。',
  'termsOfService.section9.title': '九、责任限制',
  'termsOfService.section9.1.title': '9.1 责任范围',
  'termsOfService.section9.1.intro': '在法律允许的最大范围内，我们对因使用或无法使用本服务而产生的任何直接、间接、偶然、特殊或后果性损害不承担责任，包括但不限于：',
  'termsOfService.section9.1.item1': '利润损失、数据丢失或其他经济损失',
  'termsOfService.section9.1.item2': '业务中断',
  'termsOfService.section9.1.item3': '人身伤害或财产损失',
  'termsOfService.section9.1.item4': '隐私泄露',
  'termsOfService.section9.2.title': '9.2 责任上限',
  'termsOfService.section9.2.content': '我们的总责任不超过您在过去 12 个月内通过本服务实际支付的费用总额，或 100 美元（以较高者为准）。',
  'termsOfService.section10.title': '十、服务终止',
  'termsOfService.section10.1.title': '10.1 用户终止',
  'termsOfService.section10.1.content': '您可以随时停止使用本服务并注销账户。',
  'termsOfService.section10.2.title': '10.2 平台终止',
  'termsOfService.section10.2.intro': '我们有权在以下情况下立即终止或暂停您的账户和服务：',
  'termsOfService.section10.2.item1': '您违反本服务条款',
  'termsOfService.section10.2.item2': '您从事任何非法活动',
  'termsOfService.section10.2.item3': '您的账户长期未使用',
  'termsOfService.section10.2.item4': '法律或监管要求',
  'termsOfService.section10.2.note': '服务终止后，您将无法访问账户和生成的内容，除非法律另有规定。',
  'termsOfService.section11.title': '十一、争议解决',
  'termsOfService.section11.1.title': '11.1 协商解决',
  'termsOfService.section11.1.content': '如发生争议，双方应首先通过友好协商解决。',
  'termsOfService.section11.2.title': '11.2 法律适用',
  'termsOfService.section11.2.content': '本服务条款受中华人民共和国法律管辖。如双方无法协商解决争议，应提交至我们所在地有管辖权的人民法院解决。',
  'termsOfService.section12.title': '十二、其他条款',
  'termsOfService.section12.1.title': '12.1 条款修改',
  'termsOfService.section12.1.content': '我们保留随时修改本服务条款的权利。重大修改将在生效前至少 30 天通知您。继续使用服务即表示您接受修改后的条款。',
  'termsOfService.section12.2.title': '12.2 可分割性',
  'termsOfService.section12.2.content': '如本服务条款的任何条款被认定为无效或不可执行，不影响其他条款的效力。',
  'termsOfService.section12.3.title': '12.3 完整协议',
  'termsOfService.section12.3.content': '本服务条款构成您与我们之间关于使用本服务的完整协议，取代所有先前的口头或书面协议。',
  'termsOfService.section13.title': '十三、联系我们',
  'termsOfService.section13.intro': '如您对本服务条款有任何疑问，请通过以下方式联系我们：',
  'termsOfService.section13.email': '邮箱：{email}',
  'termsOfService.section13.hours': '客服时间：工作日 9:00-18:00',
  
  // Footer
  'footer.brand.description': '提供 AI 生成服务。',
  'footer.joinUs': '加入我们',
  'footer.product.title': '产品',
  'footer.product.signup': '注册账号',
  'footer.product.login': '登录',
  'footer.product.workspace': '工作台',
  'footer.product.works': '我的作品',
  'footer.product.community': '社区',
  'footer.support.title': '支持',
  'footer.support.help': '帮助中心',
  'footer.support.about': '关于我们',
  'footer.support.feedback': '意见反馈',
  'footer.support.contact': '联系我们',
  'footer.legal.title': '法律',
  'footer.legal.privacy': '隐私政策',
  'footer.legal.terms': '服务条款',
  'footer.legal.recharge': '充值协议',
  'footer.resources.title': '资源',
  'footer.resources.invite': '邀请好友',
  'footer.resources.account': '账户管理',
  'footer.resources.orders': '订单中心',
  'footer.copyright': '© {year} {brand}. 保留所有权利。',
  'footer.description': '本平台提供 AI 生成服务',
  'footer.openRobotX.title': 'Open Robot X',
  'footer.openRobotX.description': '全球人形机器人数据库，参数对比与行业资讯',
  'footer.openRobotX.visit': '前往 Open Robot X',
  'footer.ai2obj.title': 'ai2obj',
  'footer.ai2obj.description': 'AI 综合生成平台，提供多样化的数字内容创作工具',
  'footer.aimatexMusic.title': 'AIMATEX-MUSIC',
  'footer.aimatexMusic.description': '个人云音乐空间：发现、歌单协作、正在听与云端音库',
  'footer.aimatexNas.title': 'AIMATEX-NAS / Cloud',
  'footer.aimatexNas.description': '个人数仓与云盘：云端文件、本地共享，通往 AI 数据管家',
  
  // 定价页面
  'pricing.title': '选择适合您的方案',
  'pricing.plan.basic.sub': '基础版',
  'pricing.plan.pro.sub': '专业版',
  'pricing.plan.team.sub': '团队版',
  'pricing.plan.popular': 'POPULAR',
  'pricing.plan.button.select': '选择此方案',
  'pricing.plan.button.subscribe': '立即订阅',
  'pricing.plan.basic.videoQuota': '5次/月',
  'pricing.plan.basic.videoDuration': '6-10秒',
  'pricing.plan.basic.videoQuality': '720P',
  'pricing.plan.pro.videoQuota': '30次/月',
  'pricing.plan.pro.videoDuration': '10-15秒',
  'pricing.plan.pro.videoQuality': '1080P',
  'pricing.plan.team.videoQuota': '100次/月',
  'pricing.plan.team.videoDuration': '10-15秒',
  'pricing.plan.team.videoQuality': '1080P/4K',
  'pricing.feature.videoQuota': '视频生成额度',
  'pricing.feature.videoDuration': '视频时长',
  'pricing.feature.videoQuality': '视频画质',
  'pricing.feature.storyboard': '分镜功能',
  'pricing.feature.workflow': '工作流',
  'pricing.feature.priorityQueue': '优先队列',
  'pricing.feature.exclusiveChannel': '专属通道',
  'pricing.feature.highestQuality': '最高质量模式',
  'pricing.feature.sdImage': 'SD生图',
  'pricing.feature.unlimited': '无限量',
  'pricing.feature.promptOptimization': '提示词优化',
  'pricing.feature.imageSize': '生图尺寸',
  'pricing.feature.storage': '存储空间',
  'pricing.feature.commercialLicense': '商业授权',
  'pricing.feature.apiAccess': 'API 访问',
  'pricing.then': '之后',
  'cta.title': '开始创作您的视频',
  'cta.description': '立即注册，使用 AI 技术将您的创意转化为惊艳的视频作品',
  'cta.button': '免费开始创作',
  'technology.coreArchitecture': '核心架构',
  'technology.workflowEngine.title': '可视化工作流引擎',
  'technology.workflowEngine.description': '即将支持可视化工作流。每一个节点，都是一次对创意的精准操控。',
  'technology.node.checkpointLoader': 'Checkpoint Loader',
  'technology.node.clipTextPositive': 'CLIP Text (Positive)',
  'technology.node.clipTextNegative': 'CLIP Text (Negative)',
  'technology.node.ksamplerAdvanced': 'KSampler Advanced',
  'technology.node.vaeDecode': 'VAE Decode',
  'technology.node.previewImage': 'Preview Image',
  'technology.hud.systemResourceMonitor': '系统资源监控',
  'technology.hud.gpuVram': 'GPU VRAM',
  'technology.terminal.console': 'console — zsh',
  'technology.button.runWorkflow': '运行工作流',
  'technology.button.running': '运行中...',
  'technology.log.systemInitialized': '> 系统已初始化。',
  'technology.log.waitingForInput': '> 等待用户输入...',
  'technology.log.loadingCheckpoint': 'Loading SDXL Checkpoint (fp16)...',
  'technology.log.tokenizingPrompt': 'Tokenizing positive prompt...',
  'technology.log.ksamplerSteps': 'KSampler: 30/30 steps (Euler A)',
  'technology.log.generationComplete': 'Generation complete.',
  'technology.benchmark.title': '极致性能压测',
  'technology.benchmark.description': '为了这 0.5 秒的提升，我们重写了 30% 的底层算子。',
  'technology.benchmark.fps.title': '生成速度 (FPS)',
  'technology.benchmark.fps.subtitle': 'Comparison @ 1080p',
  'technology.benchmark.vram.title': '显存优化 (VRAM)',
  'technology.benchmark.vram.subtitle': 'Lower is better',
  'technology.benchmark.productX': 'ProductX',
  'technology.benchmark.others': 'Others',
  'technology.benchmark.standard': 'Standard',
  'technology.galaxy.openEcology': '开放生态',
  'technology.galaxy.title': '无限模型宇宙',
  'technology.galaxy.description': '支持 Civitai 直连，万千模型，一键加载。',
  'technology.galaxy.autoSync': '自动同步',
  
  // 反馈页面
  'feedback.leftPanel.title.line1': '我们倾听',
  'feedback.leftPanel.title.line2': '您的声音',
  'feedback.leftPanel.description': '您的反馈是我们产品进步的动力。无论是发现 Bug，还是有绝妙的新功能点子，都请告诉我们。',
  'feedback.contact.helpDoc.title': '帮助文档',
  'feedback.contact.helpDoc.desc': '查阅常见问题与使用指南',
  'feedback.contact.email.title': '邮件支持',
  'feedback.contact.service.title': '在线客服',
  'feedback.contact.service.hours': '工作日 9:00 - 18:00',
  'feedback.type.suggestion.title': '功能建议',
  'feedback.type.suggestion.desc': '我有新想法或改进建议',
  'feedback.type.bug.title': '缺陷反馈',
  'feedback.type.bug.desc': '我遇到了错误或异常',
  'feedback.type.question.title': '使用咨询',
  'feedback.type.question.desc': '我不懂某个功能怎么用',
  'feedback.type.other.title': '其他',
  'feedback.type.other.desc': '其他类别的反馈',
  'feedback.form.type.label': '反馈类型',
  'feedback.form.title.label': '简要概述',
  'feedback.form.title.placeholder': '一句话描述您的问题或建议',
  'feedback.form.title.required': '请输入标题',
  'feedback.form.content.label': '详细描述',
  'feedback.form.content.placeholder': '请详细描述背景、重现步骤或具体建议...',
  'feedback.form.content.required': '请输入详细内容',
  'feedback.form.attachment.label': '附件 (可选)',
  'feedback.upload.dragText': '点击或拖拽文件到此处上传',
  'feedback.upload.hint': '支持 JPG, PNG, PDF 等格式，单个文件不超过 5MB',
  'feedback.upload.sizeLimit': '文件大小不能超过 5MB',
  'feedback.form.priority.label': '优先级',
  'feedback.priority.low.label': '低',
  'feedback.priority.low.desc': '不影响使用',
  'feedback.priority.medium.label': '中',
  'feedback.priority.medium.desc': '体验受影响',
  'feedback.priority.high.label': '高',
  'feedback.priority.high.desc': '严重阻碍使用',
  'feedback.form.contact.label': '联系方式 (可选)',
  'feedback.form.contact.placeholder': 'Email 或 手机号',
  'feedback.form.submit': '提交反馈',
  'feedback.submit.error': '提交失败，请稍后重试',
  'feedback.success.title': '反馈已送达！',
  'feedback.success.description': '感谢您的宝贵意见。我们的产品团队会仔细阅读每一条反馈。如果是 Bug 反馈，我们可能会通过预留的联系方式与您沟通。',
  'feedback.success.back': '返回上一页',
  'feedback.success.another': '再提一条',
  // 邀请页面
  'invite.partnerProgram': '合作伙伴计划',
  'invite.title.line1': '邀请好友',
  'invite.title.line2': '共创无限价值',
  'invite.reward.inviter': '每邀请一位好友，您将获得 {amount} 现金奖励。',
  'invite.reward.invitee': '好友注册即送 {amount} 新人礼包。',
  'invite.step1.title': '1. 分享链接',
  'invite.step1.desc': '通过微信、社群分享专属链接',
  'invite.step2.title': '2. 好友激活',
  'invite.step2.desc': '好友完成注册并验证手机号',
  'invite.step3.title': '3. 提现收益',
  'invite.step3.desc': '收益实时到账，可提现至余额',
  'invite.exclusiveCode': 'YOUR EXCLUSIVE CODE',
  'invite.copyCode': '复制邀请码',
  'invite.viewQrcode': '查看二维码',
  'invite.stats.totalInvites': '累计邀请',
  'invite.stats.availableReward': '可提现金额',
  'invite.stats.totalReward': '历史总收益',
  'invite.withdrawNow': '立即提现',
  'invite.history.title': '邀请记录',
  'invite.filter.all': '全部',
  'invite.filter.active': '已激活',
  'invite.filter.pending': '待激活',
  'invite.status.credited': '已入账',
  'invite.status.pending': '待激活',
  'invite.history.empty': '暂无记录',
  'invite.withdraw.title': '提现收益',
  'invite.withdraw.cancel': '取消',
  'invite.withdraw.confirm': '确认提现',
  'invite.withdraw.amount': '提现金额',
  'invite.withdraw.note': '* 提现金额将直接转入您的账户余额，可用于消费。',
  'invite.withdraw.enterAmount': '请输入提现金额',
  'invite.withdraw.insufficientBalance': '余额不足',
  'invite.withdraw.success': '成功提现 ¥{amount} 到余额',
  'invite.qrcode.title': '扫码加入',
  'invite.copyLink': '复制链接',
  'invite.copy.success': '复制成功',
  // 首页 Hero 区域
  'home.hero.badge': 'AI助手 · 伴侣 · 伙伴',
  'home.hero.title': 'AIMATEX',
  'home.hero.subtitle': '您的 Classmate、Soulmate、Teammate',
  'home.hero.lead': '通往旗下 AI 产品的入口。发现音乐、创作与智能工具，从这里开始。',
  'home.hero.description': 'AIMATEX 是您的AI助手、学习伙伴、创作伴侣。我们提供全方位的AI解决方案，让AI成为您工作、学习、创作中的最佳伙伴。无论是课堂学习、创意协作，还是团队合作，AIMATEX都是您值得信赖的伙伴。',
  'home.hero.cta.signup': '免费开始',
  'home.hero.cta.login': '立即登录',
  'home.hero.cta.workspace': '进入工作台',
  'home.hero.cta.explore': '探索产品',
  'home.hero.scroll': '向下浏览',
  // 首页产品区域
  'home.products.title': '我们的产品',
  'home.products.subtitle': '探索AIMATEX旗下创新AI产品，每个产品都是您在不同场景下的最佳伙伴',
  'home.products.seedance2.name': 'Seedance2',
  'home.products.seedance2.description': 'AI图生视频创作伙伴，将静态图片转化为动态视频，让您的创意动起来',
  'home.products.ai2obj.name': 'AI2Obj',
  'home.products.ai2obj.description': 'AI驱动的3D对象生成与转换平台，您的3D创作伙伴',
  'home.products.openrobotx.name': 'OpenRobotX',
  'home.products.openrobotx.description': '探索全球人形机器人公司、参数对比与行业资讯，您的机器人研究伙伴',
  'home.products.openclaw4j.name': 'OpenClaw4j',
  'home.products.openclaw4j.title': 'OpenClaw4j',
  'home.products.openclaw4j.description': '自主智能体平台，基于 OpenForgeX 构建与部署智能体',
  'home.products.openclaw4j.cta': '体验智能体',
  'home.products.aimatexMusic.name': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.title': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.description': '个人云音乐空间：发现音乐、歌单协作、正在听与云端音库，一站式管理你的音乐',
  'home.products.aimatexMusic.cta': '进入音乐站',
  'home.music.eyebrow': 'AIMATEX 产品矩阵',
  'home.music.title': 'AIMATEX-MUSIC',
  'home.music.subtitle': '个人云音乐空间：发现、收藏、歌单协作与正在听，一站式管理你的音乐。',
  'home.music.feature.discover.title': '发现音乐',
  'home.music.feature.discover.desc': '搜索曲库，一键导入云端音库。',
  'home.music.feature.playlist.title': '歌单协作',
  'home.music.feature.playlist.desc': '创建与分享歌单，和好友一起听。',
  'home.music.feature.nowPlaying.title': '正在听',
  'home.music.feature.nowPlaying.desc': '同步听歌状态、喜欢与播放历史。',
  'home.music.feature.cloud.title': '云端音库',
  'home.music.feature.cloud.desc': '高品质音频安全存储在云端。',
  'home.music.cta': '进入 AIMATEX-MUSIC',

  'home.nas.eyebrow': 'AIMATEX 产品矩阵',
  'home.nas.title': 'AIMATEX-NAS / Cloud',
  'home.nas.subtitle': '个人数仓与云盘：把云端与本地数据汇成一座只属于你的仓库，让 AI 成为你的数据管理专家。',
  'home.nas.feature.cloud.title': '官方云盘',
  'home.nas.feature.cloud.desc': '隔离的个人空间，文件随手上云、随处可取。',
  'home.nas.feature.local.title': '本地共享',
  'home.nas.feature.local.desc': '客户端接入家里电脑文件夹，网页远程管理。',
  'home.nas.feature.warehouse.title': '个人数仓',
  'home.nas.feature.warehouse.desc': '元数据、标签与时间线，让散落数据成为资产。',
  'home.nas.feature.ai.title': 'AI 数据专家',
  'home.nas.feature.ai.desc': '问答、整理与检索——在权限边界内帮你打理数据。',
  'home.nas.cta': '体验 AIMATEX-NAS',

  'home.showcase.seedance2.eyebrow': '图生视频',
  'home.showcase.seedance2.title': 'Seedance2',
  'home.showcase.seedance2.subtitle': '把静态画面变成电影级动态影像，下一站创作引擎。',
  'home.showcase.seedance2.f1.title': '图生视频',
  'home.showcase.seedance2.f1.desc': '上传一张图，AI 推演光影与运动。',
  'home.showcase.seedance2.f2.title': '电影级画质',
  'home.showcase.seedance2.f2.desc': '高分辨率输出，细节清晰稳定。',
  'home.showcase.seedance2.f3.title': '智能提示词',
  'home.showcase.seedance2.f3.desc': '不会写 prompt？AI 帮你润色成片。',
  'home.showcase.seedance2.f4.title': '多风格切换',
  'home.showcase.seedance2.f4.desc': '赛博、油画、二次元一键变换。',
  'home.showcase.seedance2.cta': '进入 Seedance2',
  'home.showcase.ai2obj.eyebrow': '3D 生成',
  'home.showcase.ai2obj.title': 'AI2Obj',
  'home.showcase.ai2obj.subtitle': 'AI 驱动的综合生成平台，把想法快速变成可用数字资产。',
  'home.showcase.ai2obj.f1.title': '多模态生成',
  'home.showcase.ai2obj.f1.desc': '文本、图像到三维与内容资产。',
  'home.showcase.ai2obj.f2.title': '对象转换',
  'home.showcase.ai2obj.f2.desc': '结构理解与格式转换一步到位。',
  'home.showcase.ai2obj.f3.title': '创作工作流',
  'home.showcase.ai2obj.f3.desc': '面向产品与内容团队的流水线。',
  'home.showcase.ai2obj.f4.title': '云端交付',
  'home.showcase.ai2obj.f4.desc': '结果可预览、导出与协作。',
  'home.showcase.ai2obj.cta': '访问 AI2Obj',
  'home.showcase.openrobotx.eyebrow': '机器人情报',
  'home.showcase.openrobotx.title': 'OpenRobotX',
  'home.showcase.openrobotx.subtitle': '全球人形机器人公司、参数对比与行业洞察一站聚合。',
  'home.showcase.openrobotx.f1.title': '全球图谱',
  'home.showcase.openrobotx.f1.desc': '覆盖主要人形机器人厂商与产品。',
  'home.showcase.openrobotx.f2.title': '参数对比',
  'home.showcase.openrobotx.f2.desc': '规格、能力与定位清晰对照。',
  'home.showcase.openrobotx.f3.title': '行业资讯',
  'home.showcase.openrobotx.f3.desc': '跟踪融资、发布与技术动态。',
  'home.showcase.openrobotx.f4.title': '研究伙伴',
  'home.showcase.openrobotx.f4.desc': '为选型与调研提供结构化信息。',
  'home.showcase.openrobotx.cta': '探索 OpenRobotX',
  'home.showcase.openclaw4j.eyebrow': '自主智能体',
  'home.showcase.openclaw4j.title': 'OpenClaw4j',
  'home.showcase.openclaw4j.subtitle': '基于 OpenForgeX 构建与部署智能体，让 Agent 真正跑起来。',
  'home.showcase.openclaw4j.f1.title': 'Agent 编排',
  'home.showcase.openclaw4j.f1.desc': '多步骤任务规划与执行。',
  'home.showcase.openclaw4j.f2.title': '工具调用',
  'home.showcase.openclaw4j.f2.desc': '连接 API 与业务系统能力。',
  'home.showcase.openclaw4j.f3.title': '可观测运行',
  'home.showcase.openclaw4j.f3.desc': '过程透明，便于调试与迭代。',
  'home.showcase.openclaw4j.f4.title': '一键部署',
  'home.showcase.openclaw4j.f4.desc': '从原型到可用服务快速上线。',
  'home.showcase.openclaw4j.cta': '体验智能体',

  'home.products.learnMore': '了解更多',
  // 首页特性区域
  'home.features.title': '全能创作工坊。',
  'home.features.subtitle': '不仅仅是生成视频，更是对创意的全方位赋能。',
  'home.features.aiPrompt.title': '不会写提示词？AI 帮你写',
  'home.features.aiPrompt.description': '完全没灵感？一键让 AI 帮你写。随便打几个词，AI 自动润色成影视级描述，10 秒出片。想改风格？再点一次，秒变赛博/油画/二次元。',
  'home.features.demo.userInput': '一只猫',
  'home.features.demo.aiResult': '一只优雅的波斯猫，柔软蓬松的白色长毛，琥珀色的大眼睛，坐在洒满阳光的窗台上。背景是淡蓝色的天空和飘动的白色窗帘。4K高清，电影级光影，景深效果，专业摄影。',
  'home.features.demo.buttonText': 'AI 生成提示词',
  'home.features.demo.buttonLoading': 'AI 生成中',
  'home.features.demo.thinkingText': 'AI 正在创作✨',
  'home.features.quality.title': '电影级画质',
  'home.features.quality.description': '原生支持 4K 分辨率输出，每一帧都细腻如画。',
  'home.features.imageToVideo.title': '图生视频',
  'home.features.imageToVideo.description': '上传一张静态图片，AI 将理解画面中的光影与物理关系，自动推演后续动态，让照片活过来。',
  'home.features.multimodal.title': '多模态生态',
  'home.features.multimodal.description': '不仅支持 Stable Diffusion 文生图，更集成了 Midjourney 风格迁移与 ElevenLabs 音频合成。在一个工作流中完成所有创作。',
  
  // 首页社区区域
  'home.community.title': '探索AI创作社区',
  'home.community.subtitle': '加入数百万创作者，分享你的AI杰作，获取灵感与反馈',
  'home.community.hot': '热门',
  'home.community.explore': '探索社区',
  'home.community.stats.works': '作品',
  'home.community.stats.creators': '创作者',
  'home.community.stats.views': '浏览',
  'home.community.image.title': 'AI图片社区',
  'home.community.image.description': '欣赏和分享由AI创作的惊艳图片，从写实到艺术，从插画到摄影，探索无限视觉可能',
  'home.community.video.title': 'AI视频社区',
  'home.community.video.description': '发现震撼的AI生成视频作品，学习创作技巧，与全球视频创作者交流经验',
  'home.community.music.title': 'AI音乐社区',
  'home.community.music.description': '聆听AI谱写的美妙旋律，分享你的音乐作品，在这里找到志同道合的音乐爱好者',
  'home.community.3d.title': 'AI 3D模型社区',
  'home.community.3d.description': '探索AI生成的3D模型世界，从建筑到角色，从游戏到工业设计，尽在这里',
  'home.community.voice.title': 'AI语音社区',
  'home.community.voice.description': '体验逼真的AI语音合成，配音、有声读物、语音克隆，让创作发声',
  'home.community.text.title': 'AI文本社区',
  'home.community.text.description': '分享AI创作的精彩文字，小说、诗歌、剧本、文案，激发你的文学灵感',

  // 提示词商城 (Prompt Market Section)
  'market.label': '提示词商城',
  'market.h1': '释放你的',
  'market.h1.highlight': '无限创意。',
  'market.sub': '一站式 AI 提示词平台：覆盖文生图、文生视频、文生音乐。经验证的顶流模型配方，兼容 OpenAI、Google、Midjourney、Runway、Kling、Luma、Suno、ElevenLabs 等主流生态。不再试错，直接创作。',
  'market.providers.title': '兼容主流模型与平台',
  'market.card1.title': '即装即用',
  'market.card1.desc': '跳过漫长的提示词学习曲线。一键将久经考验的提示词导入你的工作流。',
  'market.card2.title': '创意变现',
  'market.card2.desc': '把最拿手的提示词变成被动收入。与万千创作者一起，用 AI 专长获得收益。',
  'market.card3.title': '品质保障',
  'market.card3.desc': '每一条上架内容均经人工审核与测试，确保在不同模型下输出稳定可靠。',
  'market.card4.title': '探索实验室',
  'market.card4.desc': '发现社区生成的 10,000+ 优质素材，灵感触手可及。',
  'market.cta': '进入提示词商城',
  'home.mediaTools.title': '实用媒体工具',
  'home.mediaTools.subtitle': '在线使用，无需安装，轻松处理您的图片、视频和音频文件',
  'home.mediaTools.toolSuffix': '工具',
  'home.mediaTools.imageCompress.title': '图片压缩',
  'home.mediaTools.imageCompress.description': '智能压缩图片大小，保持画质清晰，支持批量处理',
  'home.mediaTools.videoCompress.title': '视频压缩',
  'home.mediaTools.videoCompress.description': '高效压缩视频文件，自定义分辨率和码率，支持多种格式',
  'home.mediaTools.audioCompress.title': '音频压缩',
  'home.mediaTools.audioCompress.description': '优化音频文件大小，保持音质清晰，支持MP3、AAC等格式',

  // Billing 页面
  'billing.page.title': '财务中心',
  'billing.page.description': '管理您的资金往来与账单明细',
  'billing.button.refresh': '刷新',
  'billing.button.recharge': '充值',
  'billing.button.reset': '重置',
  'billing.button.apply': '确认筛选',
  
  // 余额卡片
  'billing.balance.cny': 'CNY余额',
  'billing.balance.usdt': 'USDT余额',
  'billing.balance.usd': 'USD余额',
  'billing.balance.token': 'Token余额',
  'billing.balance.frozen': '冻结',
  
  // 交易类型
  'billing.type.frozen': '资金冻结',
  'billing.type.aiModelFee': '模型调用',
  'billing.type.recharge': '充值',
  'billing.type.refund': '退款',
  'billing.type.reward': '奖励',
  'billing.type.all': '全部类型',
  
  // 币种
  'billing.coin.all': '全部币种',
  'billing.coin.usdt': 'USDT',
  'billing.coin.cny': 'CNY',
  'billing.coin.usd': 'USD',
  'billing.coin.token': 'TOKEN',
  
  // 表格
  'billing.table.type': '类型',
  'billing.table.coinType': '币种',
  'billing.table.time': '时间',
  'billing.table.amount': '金额',
  'billing.table.remark': '备注',
  'billing.table.balance': '结余',
  'billing.table.empty': '暂无账单',
  
  // 筛选
  'billing.filter.title': '筛选条件',
  'billing.filter.button': '筛选交易 & 日期',
  'billing.filter.changeType': '变更类型',
  'billing.filter.coinType': '币种类型',
  'billing.filter.remark': '备注搜索',
  'billing.filter.remarkPlaceholder': '输入备注关键词',
  'billing.filter.remarkSearch': '备注搜索',
  'billing.filter.dateQuick': '快捷时间',
  'billing.filter.dateCustom': '自定义日期',
  'billing.filter.dateTo': '至',
  'billing.filter.days7': '近7天',
  'billing.filter.days30': '近30天',
  'billing.filter.days90': '近3个月',
  
  // 占位符
  'billing.placeholder.changeType': '变更类型',
  'billing.placeholder.coinType': '币种',
  'billing.placeholder.remark': '备注搜索',
  
  // 消息
  'billing.message.fetchBalanceError': '获取余额失败',
  'billing.message.fetchRecordsError': '获取账单记录失败',
  'billing.message.tryAgain': '获取账单记录失败，请稍后重试',
  
  // Recharge 充值页面
  'recharge.page.title': '账户充值',
  'recharge.page.backLink': '返回财务中心',
  'recharge.balance.title': '账户余额',
  'recharge.balance.refresh': '刷新',
  
  // 充值区块
  'recharge.section.coinType': '充值币种',
  'recharge.section.paymentMethod': '支付方式',
  'recharge.section.amount': '充值金额',
  
  // 订单详情
  'recharge.order.title': '订单详情',
  'recharge.order.type': '充值类型',
  'recharge.order.typeValue': '账户余额充值',
  'recharge.order.account': '充值账号',
  'recharge.order.accountLoading': '加载中...',
  'recharge.order.paymentMethod': '支付方式',
  'recharge.order.paymentMethodPlease': '请选择',
  'recharge.order.total': '应付总额',
  
  // 按钮
  'recharge.button.pay': '立即支付',
  'recharge.button.customize': '自定义金额',
  
  // 输入框占位符
  'recharge.placeholder.customAmount': '输入自定义金额',
  
  // 安全认证
  'recharge.security.ssl': 'SSL 安全加密传输，保障资金安全',
  'recharge.security.agreement': '点击支付即代表您同意',
  'recharge.security.agreementLink': '《充值服务协议》',
  
  // 空状态提示
  'recharge.empty.noCurrency': '暂无支持的货币',
  'recharge.empty.noPaymentMethod': '暂不支持 {currency} 币种的支付方式',
  'recharge.empty.pleaseSelectCurrency': '请先选择充值币种',
  'recharge.empty.pleaseSelectPayment': '请先选择支付方式',
  'recharge.empty.noProducts': '暂无可用产品',
  'recharge.empty.noPresets': '暂不支持 {currency} 币种的预设金额',
  
  // 消息提示
  'recharge.message.invalidAmount': '请输入有效金额',
  'recharge.message.selectPaymentMethod': '请选择支付方式',
  'recharge.message.selectAmount': '请选择充值金额',
  'recharge.message.fetchBalanceError': '获取余额失败，请稍后重试',
  'recharge.message.fetchUserInfoError': '获取用户信息失败',
  'recharge.message.fetchCurrenciesError': '获取货币列表失败，请稍后重试',
  'recharge.message.fetchPaymentMethodsError': '获取支付方式失败，请稍后重试',
  'recharge.message.fetchCreemProductsError': '获取 Creem 产品列表失败，请稍后重试',
  'recharge.message.fetchCreemProductsWarning': '获取 Creem 产品列表失败',
  'recharge.message.orderCreated': '订单创建成功',
  'recharge.message.orderCreateFailed': '创建充值订单失败',
  'recharge.message.paymentProcessing': '正在打开支付页面，请完成支付...',
  'recharge.message.popupBlocked': '无法打开支付窗口，请检查浏览器弹窗设置',
  'recharge.message.paymentUrlError': '获取支付链接失败',
  'recharge.message.checkoutSessionError': '创建支付会话失败',
  'recharge.message.paymentError': '支付处理失败，请稍后重试',
  'recharge.message.redirecting': '正在跳转支付页面，请完成支付...',
  'recharge.message.paymentUrlFailed': '支付链接获取失败',
  'recharge.message.paymentSuccess': '支付成功！余额已到账',
  'recharge.message.orderCancelled': '订单已取消',
  'recharge.message.paymentFailed': '支付失败',
  'recharge.message.orderExpired': '已过期',
  'recharge.message.queryOrderError': '查询订单状态失败',
  'recharge.message.rechargeError': '充值请求失败，请稍后重试',

  // Orders 页面
  'orders.title': '订单记录',
  'orders.subtitle': '查看您的所有充值订单记录和状态',
  'orders.refresh': '刷新',
  'orders.goToRecharge': '去充值',

  // 统计卡片
  'orders.stats.totalOrders': '总订单数',
  'orders.stats.pending': '待支付',
  'orders.stats.paid': '已支付',
  'orders.stats.totalAmount': '总充值金额',

  // 表格列
  'orders.table.orderNo': '订单号',
  'orders.table.createTime': '创建时间',
  'orders.table.amount': '金额',
  'orders.table.paymentMethod': '支付方式',
  'orders.table.status': '状态',
  'orders.table.action': '操作',
  'orders.table.view': '查看',
  'orders.table.cancel': '取消',
  'orders.table.empty': '暂无订单记录',

  // 订单状态
  'orders.status.pending': '待支付',
  'orders.status.paid': '已支付',
  'orders.status.success': '已完成',
  'orders.status.cancelled': '已取消',
  'orders.status.failed': '支付失败',
  'orders.status.expired': '已过期',
  'orders.status.all': '全部状态',

  // 支付方式
  'orders.payment.alipay': '支付宝',
  'orders.payment.wechat': '微信支付',
  'orders.payment.bank': '银行卡',
  'orders.payment.usdt': 'USDT',
  'orders.payment.creem': 'Creem',
  'orders.payment.all': '全部方式',

  // 币种
  'orders.coin.all': '全部币种',

  // 筛选
  'orders.filter.title': '筛选条件',
  'orders.filter.button': '筛选订单',
  'orders.filter.reset': '重置',
  'orders.filter.apply': '确认筛选',
  'orders.filter.orderStatus': '订单状态',
  'orders.filter.paymentMethod': '支付方式',
  'orders.filter.coinType': '币种类型',
  'orders.filter.orderNoSearch': '订单号搜索',
  'orders.filter.quickDate': '快捷时间',
  'orders.filter.customDate': '自定义日期',
  'orders.filter.dateTo': '至',
  'orders.filter.last7Days': '近7天',
  'orders.filter.last30Days': '近30天',
  'orders.filter.last3Months': '近3个月',

  // 搜索和输入
  'orders.search.placeholder': '搜索订单号',
  'orders.input.orderNo': '输入订单号',
  'orders.select.orderStatus': '订单状态',
  'orders.select.paymentMethod': '支付方式',
  'orders.select.coinType': '币种',

  // 消息提示
  'orders.message.fetchError': '获取订单记录失败',
  'orders.message.fetchErrorRetry': '获取订单记录失败，请稍后重试',
  'orders.message.statsError': '获取统计数据失败',
  'orders.message.cancelSuccess': '订单已取消',
  'orders.message.cancelError': '取消订单失败',
  'orders.message.cancelErrorRetry': '取消订单失败，请稍后重试',
  'orders.message.viewOrder': '订单号: {orderNo}',

  // 确认对话框
  'orders.confirm.cancel': '确定要取消这个订单吗？',
  'orders.confirm.ok': '确定',
  'orders.confirm.cancelButton': '取消',

  // 加入我们页面
  'joinUs.seo.title': '加入 PROTX - 追求极致体验',
  'joinUs.seo.description': '加入 PROTX 团队，与我们一起追求极致的用户体验和产品设计',
  'joinUs.hero.eyebrow': 'JOIN PROTX',
  'joinUs.hero.title': '追求极致',
  'joinUs.hero.title2': '用设计定义未来',
  'joinUs.hero.subtitle': 'PROTX 是一支追求极致用户体验和产品设计的团队。我们相信每一个像素都有意义，每一次交互都值得被精心雕琢。如果你和我们一样对卓越有着执着的追求，欢迎加入。',
  'joinUs.hero.cta': '查看开放职位',
  'joinUs.hero.video': '观看团队故事',
  
  // 价值观
  'joinUs.values.eyebrow': '我们的理念',
  'joinUs.values.title': '我们的价值观',
  'joinUs.values.subtitle': '这些核心价值观定义了我们是谁，以及我们如何共同工作',
  'joinUs.values.innovation.title': '创新驱动',
  'joinUs.values.innovation.desc': '我们相信创新是改变世界的力量，鼓励每一个突破性的想法。',
  'joinUs.values.collaboration.title': '协作共赢',
  'joinUs.values.collaboration.desc': '跨团队协作，共同创造非凡成果。',
  'joinUs.values.excellence.title': '追求卓越',
  'joinUs.values.excellence.desc': '不断突破自我，追求极致体验。',
  'joinUs.values.passion.title': '热爱与专注',
  'joinUs.values.passion.desc': '对技术的热爱，对产品的专注。',
  'joinUs.values.impact.title': '影响力',
  'joinUs.values.impact.desc': '让 AI 技术赋能每一个人的创意表达。',
  
  // 职位
  'joinUs.positions.eyebrow': '开放职位',
  'joinUs.positions.title': '开放职位',
  'joinUs.positions.subtitle': '找到适合你的角色，开启新的职业旅程',
  'joinUs.category.engineering': '工程技术',
  'joinUs.category.product': '产品设计',
  'joinUs.category.operations': '运营市场',
  'joinUs.position.seniorFrontend': '高级前端工程师',
  'joinUs.position.backendEngineer': '后端开发工程师',
  'joinUs.position.mlEngineer': 'AI/ML 算法工程师',
  'joinUs.position.productManager': '产品经理',
  'joinUs.position.uxDesigner': 'UX 设计师',
  'joinUs.position.communityManager': '社区运营经理',
  'joinUs.position.contentCreator': '内容创作者',
  'joinUs.location.remote': '远程',
  'joinUs.location.beijing': '北京',
  'joinUs.location.shanghai': '上海',
  'joinUs.location.shenzhen': '深圳',
  'joinUs.type.fulltime': '全职',
  'joinUs.type.parttime': '兼职',
  
  // 福利
  'joinUs.benefits.eyebrow': '团队福利',
  'joinUs.benefits.title': '我们提供的福利',
  'joinUs.benefits.subtitle': '加入我们，享受全面的福利与支持',
  'joinUs.benefit.flexible.title': '弹性工作',
  'joinUs.benefit.flexible.desc': '灵活的工作时间与远程办公选择',
  'joinUs.benefit.equity.title': '期权激励',
  'joinUs.benefit.equity.desc': '与公司共同成长，分享发展成果',
  'joinUs.benefit.health.title': '健康保障',
  'joinUs.benefit.health.desc': '全面的医疗保险与健康福利',
  'joinUs.benefit.growth.title': '职业发展',
  'joinUs.benefit.growth.desc': '持续学习与成长的培训机会',
  
  // CTA
  'joinUs.cta.title': '准备好开始了吗？',
  'joinUs.cta.subtitle': '如果你对我们的使命充满热情，我们期待收到你的申请',
  'joinUs.cta.button': '立即申请',
  
  // 申请表单
  'joinUs.modal.title': '职位申请',
  'joinUs.apply.success': '申请已提交，我们会尽快与您联系！',
  'joinUs.form.name': '姓名',
  'joinUs.form.name.required': '请输入姓名',
  'joinUs.form.name.placeholder': '请输入您的姓名',
  'joinUs.form.email': '邮箱',
  'joinUs.form.email.required': '请输入邮箱',
  'joinUs.form.email.invalid': '请输入有效的邮箱地址',
  'joinUs.form.email.placeholder': '请输入您的邮箱',
  'joinUs.form.phone': '手机号码',
  'joinUs.form.phone.placeholder': '请输入您的手机号码',
  'joinUs.form.experience': '工作经验',
  'joinUs.form.experience.placeholder': '请选择工作经验',
  'joinUs.form.experience.0-2': '0-2年',
  'joinUs.form.experience.3-5': '3-5年',
  'joinUs.form.experience.5-10': '5-10年',
  'joinUs.form.experience.10+': '10年以上',
  'joinUs.form.resume': '简历',
  'joinUs.form.resume.hint': '点击或拖拽文件到此处上传',
  'joinUs.form.resume.format': '支持 PDF、DOC、DOCX 格式',
  'joinUs.form.message': '自我介绍',
  'joinUs.form.message.placeholder': '简单介绍一下自己，为什么想加入我们？',
  'joinUs.form.submit': '提交申请',
  'joinUs.form.loginTip': '登录后提交可查看申请记录',
  'joinUs.form.goLogin': '去登录',
  'joinUs.form.resume.sizeLimit': '文件大小不能超过 10MB',
  
  // 我的申请
  'joinUs.myApplications.eyebrow': '我的申请',
  'joinUs.myApplications.title': '申请记录',
  'joinUs.myApplications.empty': '暂无申请记录，快去投递简历吧！',
  'joinUs.myApplications.viewDetail': '查看详情',
  'joinUs.myApplications.detailTitle': '申请详情',
  'joinUs.status.pending': '待处理',
  'joinUs.status.reviewing': '审核中',
  'joinUs.status.interview': '面试中',
  'joinUs.status.accepted': '已录用',
  'joinUs.status.rejected': '已拒绝',
  'joinUs.detail.basicInfo': '基本信息',
  'joinUs.detail.positionInfo': '职位信息',
  'joinUs.detail.position': '申请职位',
  'joinUs.detail.category': '职位分类',
  'joinUs.detail.location': '工作地点',
  'joinUs.detail.applyTime': '申请时间',
  'joinUs.detail.downloadResume': '下载简历',
  'joinUs.detail.status': '申请状态',

  // About 页面
  'about.hero.title1': '开源内核。',
  'about.hero.title2': '无限可能。',
  'about.hero.subtitle1': '基于',
  'about.hero.subtitle2': '与',
  'about.hero.subtitle3': '生态。',
  'about.hero.description': '我们将最前沿的 2025 生成式 AI 技术栈，封装进极致的交互体验中。',
  'about.tech.poweredBy': '由',
  'about.philosophy.title1': '不仅仅是生成。',
  'about.philosophy.title2': '这是全流程的',
  'about.philosophy.title3': '创造力引擎。',
  'about.philosophy.description': '从文生图的精准控制，到视频生成的物理模拟，我们追求技术的极限。',
  'about.bento.comfy.title': '节点级精准控制。',
  'about.bento.comfy.description': '底层采用 ComfyUI 节点式架构，支持 ControlNet 姿态控制、IP-Adapter 风格迁移。我们把复杂的节点逻辑封装为直觉化的滑块，让每一次生成都如你所愿。',
  'about.bento.opensource.title': '拥抱开源生态。',
  'about.bento.opensource.description': '基于 Stable Diffusion 3.5 & XL Turbo。不仅生成速度飞快，更拥有社区海量 LoRA 模型支持。',
  'about.bento.video.title': 'DiT 视频架构。',
  'about.bento.video.description': '引入 Diffusion Transformer (DiT) 与时空注意力机制，实现 SORA 级别的物理世界模拟。',
  'about.bento.audio.title': '音画同步，感官觉醒。',
  'about.bento.audio.description': '不仅仅是视觉。集成最新的音频生成模型，支持 Text-to-Audio 与视频画面的自动对齐。从视觉到听觉，构建完整的沉浸式体验。',
  'about.techSection.title': '技术架构解析。',
  'about.techSection.description': '深入了解驱动 ProductX 的核心引擎。',
  'about.techCard.sd.title': '生成式绘画的基石。',
  'about.techCard.sd.description': '我们深度集成了 Stable Diffusion 最新的生成模型。通过自定义的 VAE 和优化的采样器（Sampler），我们在保证画质细腻的同时，将生成速度提升了 300%。',
  'about.techCard.spec.baseModel': '基础模型',
  'about.techCard.spec.resolution': '分辨率',
  'about.techCard.spec.resolution.value': '最高支持 4K 放大',
  'about.techCard.spec.control': '控制方式',
  'about.techCard.spec.speed': '生成速度',
  'about.techCard.spec.speed.value': '< 1秒（极速模式）',
  'about.techCard.video.title': '下一代视频物理引擎。',
  'about.techCard.video.description': '摒弃传统的 2D 动画逻辑，采用 2025 最新的 DiT (Diffusion Transformer) 架构。模型理解光影、重力与物体运动规律，生成的不仅仅是视频，而是符合物理逻辑的动态世界。',
  'about.techCard.spec.architecture': '架构',
  'about.techCard.spec.frameRate': '帧率',
  'about.techCard.spec.frameRate.value': '24 / 60 FPS 插帧',
  'about.techCard.spec.consistency': '一致性',
  'about.techCard.spec.consistency.value': '高时序稳定性',
  'about.techCard.spec.length': '时长',
  'about.techCard.spec.length.value': '无限循环扩展',
  'about.techCard.img2img.title': '图生图与风格迁移。',
  'about.techCard.img2img.description': '利用 IP-Adapter 和 T2I-Adapter 技术，我们实现了零样本（Zero-shot）风格迁移。上传一张参考图，即可瞬间复刻其构图、光影与艺术风格，让创意无限裂变。',
  'about.techCard.spec.technology': '核心技术',
  'about.techCard.spec.precision': '精度',
  'about.techCard.spec.precision.value': '像素级精准修复',
  'about.cta.title': '准备好体验未来了吗？',
  'about.cta.description': '加入专业创作者的行列，释放 AI 的极致潜能。',
  'about.cta.button.start': '立即开始',
  'about.cta.button.docs': '阅读技术文档',
  
  // Community 社区
  'community.explore.title': '探索社区',
  'community.explore.subtitle': '发现灵感，混音工作流，与数千名 AI 创作者连接。',
  'community.posts': '{count} 个帖子',
  'community.empty': '暂无社区频道',
  'community.loadFailed': '加载失败',
  'community.noPosts': '暂无帖子',
  'community.challenge.loadFailed': '加载挑战数据失败',
  
  // Common messages
  'common.loadFailed': '加载失败',
  'common.operationFailed': '操作失败',
  'common.error': '操作失败',
  'common.publish': '发布',
  'common.back': '返回',
  'common.backToCommunity': '返回社区',
  'common.copy': '复制',
  'common.copied': '已复制',
  'common.follow': '关注',
  'common.processing': '处理中...',
  'common.viewCount': '{count} 次浏览',
  'common.loadMore': '加载更多',
  'common.search': '搜索...',
  'common.notFound': '未找到',
  'common.description': '描述',
  
  // User related
  'user.followSuccess': '关注成功',
  'user.unfollowSuccess': '取消关注成功',
  'user.following': '已关注',
  'user.mutual_follow': '互相关注',
  
  // Post related
  'post.untitled': '未命名作品',
  'post.prompt': '提示词',
  'post.negativePrompt': '负面提示词',
  'post.details': '详细信息',
  'post.model': '模型',
  'post.resolution': '分辨率',
  'post.steps': '步数',
  'post.cfgScale': '引导比例',
  'post.remix': '混音 / 尝试这个',
  
  // Challenge related
  'challenge.status.upcoming': '即将开始',
  'challenge.status.live': '进行中',
  'challenge.status.voting': '投票中',
  'challenge.status.ended': '已结束',
  'challenge.status.unknown': '未知',
  'challenge.allChallenges': '所有挑战',
  'challenge.entriesCount': '{count} 个作品',
  'challenge.tab.submissions': '作品',
  'challenge.tab.rules': '规则与说明',
  'challenge.requirements': '要求',
  'challenge.req.original': '必须是原创作品。',
  'challenge.req.model': '必须使用模型：{model}',
  'challenge.req.tags': '必须包含标签：',
  'challenge.req.resolution': '分辨率必须至少为 1024x1024。',
  'challenge.req.nsfw': '禁止 NSFW 内容。',
  'challenge.timeRemaining': '剩余时间',
  'challenge.startsIn': '距离开始',
  'challenge.notStarted': '挑战未开始',
  'challenge.closed': '挑战已结束',
  'challenge.submitEntry': '提交作品',
  'challenge.viewWinners': '查看获奖者',
  'challenge.readRulesTip': '提交前请阅读规则',
  'challenge.prizePool': '奖金池',
  'challenge.totalValue': '总价值',
  'challenge.rank.1st': '第一名',
  'challenge.rank.2nd': '第二名',
  'challenge.rank.3rd': '第三名',
  'challenge.share': '分享挑战',
  'challenge.noEntries': '暂无作品。成为第一个提交的人！',
  'challenge.noChallenges': '未找到挑战',
  // MediaTools
  'mediaTools.tab.imageCompress': '图片压缩',
  'mediaTools.tab.videoCompress': '视频压缩',
  'mediaTools.tab.audioCompress': '音频压缩',
  'mediaTools.tab.formatConvert': '格式转换',
  // ImageCompress
  'imageCompress.title': '专业图片压缩工具',
  'imageCompress.subtitle': '智能压缩，专业品质',
  'imageCompress.upload': '上传图片',
  'imageCompress.addImages': '添加图片',
  'imageCompress.uploadToStart': '上传图片开始压缩',
  'imageCompress.settings': '设置',
  'imageCompress.clearAll': '清空全部',
  'imageCompress.totalSavings': '节省空间',
  'imageCompress.totalSize': '总大小',
  'imageCompress.quality': '质量',
  'imageCompress.resize': '尺寸调整',
  'imageCompress.scalePercent': '缩放百分比',
  'imageCompress.customPx': '自定义像素',
  'imageCompress.presetSize': '预设尺寸',
  'imageCompress.width': '宽度',
  'imageCompress.height': '高度',
  'imageCompress.format': '格式',
  'imageCompress.format.auto': '自动（保持原格式）',
  'imageCompress.format.jpeg': 'JPEG（照片）',
  'imageCompress.format.png': 'PNG（无损）',
  'imageCompress.format.webp': 'WebP（最佳）',
  'imageCompress.pngLossless': 'PNG 是无损格式。质量滑块已隐藏。',
  'imageCompress.cacheSettings': '缓存设置',
  'imageCompress.cacheTooltip': '启用后，上传的图片将保存到浏览器缓存中，刷新页面后可恢复。',
  'imageCompress.saveToCache': '保存图片到浏览器缓存',
  'imageCompress.batchProcessing': '批量处理',
  'imageCompress.batchTooltip': '启用后，将使用当前设置压缩所有 {count} 张图片。',
  'imageCompress.applyToAll': '应用设置到所有图片（{count}）',
  'imageCompress.compress': '应用并压缩',
  'imageCompress.compressAll': '应用并压缩全部（{count}）',
  'imageCompress.compressing': '压缩中...',
  'imageCompress.compressAllProgress': '正在压缩 {count} 张图片...',
  'imageCompress.download': '下载图片',
  'imageCompress.downloadAll': '下载全部（{count}）',
  'imageCompress.downloadAllCheckbox': '下载全部 {count} 张图片',
  'imageCompress.original': '原图',
  'imageCompress.compressed': '压缩后',
  // Messages
  'imageCompress.message.compressed': '压缩成功！',
  'imageCompress.message.larger': '输出文件更大。尝试降低质量。',
  'imageCompress.message.failed': '压缩失败',
  'imageCompress.message.batchSuccess': '成功压缩 {success} 张图片{failed}',
  'imageCompress.message.batchFailed': '所有压缩都失败了',
  'imageCompress.message.noImagesToDownload': '没有可下载的压缩图片',
  'imageCompress.message.downloading': '正在下载 {count} 张图片...',
  // Preset sizes
  'imageCompress.preset.instagramPost': 'Instagram 帖子 (1:1)',
  'imageCompress.preset.square': '正方形 (1:1)',
  'imageCompress.preset.facebookCover': 'Facebook 封面 (16:9)',
  'imageCompress.preset.twitterHeader': 'Twitter 横幅 (3:1)',
  'imageCompress.preset.youtubeThumbnail': 'YouTube 缩略图 (16:9)',
  'imageCompress.preset.facebookPost': 'Facebook 帖子 (1.91:1)',
  'imageCompress.preset.instagramStory': 'Instagram 动态 (9:16)',
  'imageCompress.preset.tiktok': 'TikTok (9:16)',
  'imageCompress.preset.4kUHD': '4K UHD (16:9)',
  'imageCompress.preset.2kQHD': '2K QHD (16:9)',
  'imageCompress.preset.fullHD': '全高清 (16:9)',
  'imageCompress.preset.hd': '高清 (16:9)',
  'imageCompress.preset.landscape16:9': '16:9 横向',
  'imageCompress.preset.classic4:3': '4:3 经典',
  'imageCompress.preset.photo3:2': '3:2 照片',
  'imageCompress.preset.ultrawide21:9': '21:9 超宽屏',
  'imageCompress.preset.a4Portrait': 'A4 纵向 (8.27×11.69")',
  'imageCompress.preset.a4Landscape': 'A4 横向 (11.69×8.27")',
  'imageCompress.preset.letterPortrait': 'Letter 纵向 (8.5×11")',
  // VideoCompress
  'videoCompress.title': '专业视频压缩工具',
  'videoCompress.subtitle': '浏览器端压缩，保护隐私',
  'videoCompress.upload': '上传视频',
  'videoCompress.uploadToStart': '上传视频开始压缩',
  'videoCompress.settings': '设置',
  'videoCompress.clearAll': '清空全部',
  'videoCompress.totalSavings': '节省空间',
  'videoCompress.totalSize': '总大小',
  'videoCompress.videoInfo': '视频信息',
  'videoCompress.quality': '质量',
  'videoCompress.crf': 'CRF (质量)',
  'videoCompress.crfTooltip': 'CRF值越小质量越好，18-28为常用范围',
  'videoCompress.bitrate': '比特率',
  'videoCompress.bitrateNote': '选择比特率将覆盖CRF设置',
  'videoCompress.resolution': '分辨率',
  'videoCompress.fps': '帧率',
  'videoCompress.fpsPlaceholder': '保持原帧率',
  'videoCompress.format': '格式',
  'videoCompress.compress': '开始压缩',
  'videoCompress.compressing': '压缩中...',
  'videoCompress.compressingProgress': '正在压缩视频，请稍候...',
  'videoCompress.download': '下载视频',
  'videoCompress.original': '原视频',
  'videoCompress.compressed': '压缩后',
  // Messages
  'videoCompress.message.compressed': '压缩成功！',
  'videoCompress.message.failed': '压缩失败，请重试',
  'videoCompress.message.invalidFile': '请选择视频文件',
  'videoCompress.message.loadFailed': '加载视频失败',
  'videoCompress.message.downloading': '开始下载',
  // AudioCompress
  'audioCompress.title': '专业音频压缩工具',
  'audioCompress.subtitle': '浏览器端压缩，保护隐私',
  'audioCompress.upload': '上传音频',
  'audioCompress.uploadNew': '点击上传新音频',
  'audioCompress.uploadToStart': '上传音频开始压缩',
  'audioCompress.settings': '设置',
  'audioCompress.clearAll': '清空全部',
  'audioCompress.totalSavings': '节省空间',
  'audioCompress.totalSize': '总大小',
  'audioCompress.audioInfo': '音频信息',
  'audioCompress.quality': '质量',
  'audioCompress.bitrate': '比特率',
  'audioCompress.bitrate.320': '320 kbps (最高质量)',
  'audioCompress.bitrate.256': '256 kbps (高质量)',
  'audioCompress.bitrate.192': '192 kbps (标准质量)',
  'audioCompress.bitrate.128': '128 kbps (中等质量)',
  'audioCompress.bitrate.96': '96 kbps (低质量)',
  'audioCompress.bitrate.64': '64 kbps (最低质量)',
  'audioCompress.format': '格式',
  'audioCompress.format.mp3': 'MP3 (推荐)',
  'audioCompress.format.ogg': 'OGG',
  'audioCompress.format.aac': 'AAC',
  'audioCompress.format.wav': 'WAV',
  'audioCompress.sampleRate': '采样率',
  'audioCompress.sampleRate.48000': '48000 Hz',
  'audioCompress.sampleRate.44100': '44100 Hz (CD质量)',
  'audioCompress.sampleRate.32000': '32000 Hz',
  'audioCompress.sampleRate.22050': '22050 Hz',
  'audioCompress.sampleRate.16000': '16000 Hz',
  'audioCompress.compress': '开始压缩',
  'audioCompress.compressing': '压缩中...',
  'audioCompress.download': '下载音频',
  // AudioCompress Messages
  'audioCompress.message.compressed': '压缩成功！',
  'audioCompress.message.failed': '压缩失败，请重试',
  'audioCompress.message.invalidFile': '请选择音频文件！',
  'audioCompress.message.loadError': '加载音频文件失败',
  // Settings Page
  'settings.title': '系统设置',
  'settings.description': '个性化您的 AI 生成平台体验',
  // Notifications
  'settings.notifications.title': '通知设置',
  'settings.notifications.description': '管理您接收通知的方式',
  'settings.notifications.email': '邮件通知',
  'settings.notifications.emailDesc': '接收重要更新和任务完成的邮件',
  'settings.notifications.push': '推送通知',
  'settings.notifications.pushDesc': '接收实时推送消息',
  'settings.notifications.sound': '声音提醒',
  'settings.notifications.soundDesc': '收到通知时播放提示音',
  'settings.notifications.volume': '通知音量',
  'settings.notifications.volumeDesc': '调整通知提示音的音量大小',
  'settings.notifications.marketing': '营销推广',
  'settings.notifications.marketingDesc': '接收平台活动和优惠信息',
  // Interface
  'settings.interface.title': '界面外观',
  'settings.interface.description': '自定义界面的显示效果',
  'settings.interface.theme': '主题模式',
  'settings.interface.themeDesc': '选择您喜欢的界面主题',
  'settings.interface.language': '语言',
  'settings.interface.languageDesc': '选择界面显示语言',
  'settings.interface.animation': '动画效果',
  'settings.interface.animationDesc': '开启界面过渡动画',
  'settings.interface.tips': '新手提示',
  'settings.interface.tipsDesc': '显示功能引导和提示',
  'settings.theme.light': '浅色',
  'settings.theme.dark': '深色',
  'settings.theme.auto': '自动',
  // AI Settings
  'settings.ai.title': 'AI 生成设置',
  'settings.ai.description': '优化 AI 生成效果和性能',
  'settings.ai.autoOptimize': '智能优化',
  'settings.ai.autoOptimizeDesc': 'AI 自动优化生成参数以获得最佳效果',
  'settings.ai.quality': '生成质量',
  'settings.ai.qualityDesc': '平衡速度和质量',
  'settings.ai.cloudSync': '云端同步',
  'settings.ai.cloudSyncDesc': '自动同步作品到云端',
  'settings.ai.autoSave': '自动保存',
  'settings.ai.autoSaveDesc': '生成完成后自动保存结果',
  'settings.ai.safetyFilter': '内容安全过滤',
  'settings.ai.safetyFilterDesc': '自动过滤不适宜内容',
  'settings.ai.watermark': '添加水印',
  'settings.ai.watermarkDesc': '自动为生成的作品添加水印',
  'settings.ai.promptSuggestions': '提示词建议',
  'settings.ai.promptSuggestionsDesc': '智能推荐提示词优化建议',
  'settings.quality.fast': '快速',
  'settings.quality.balanced': '平衡',
  'settings.quality.high': '高质量',
  // Privacy
  'settings.privacy.title': '隐私与安全',
  'settings.privacy.description': '保护您的个人信息',
  'settings.privacy.profile': '个人资料可见性',
  'settings.privacy.profileDesc': '允许其他用户查看您的个人资料',
  'settings.privacy.activity': '显示活动状态',
  'settings.privacy.activityDesc': '让好友看到您的在线状态',
  'settings.privacy.analytics': '分析数据收集',
  'settings.privacy.analyticsDesc': '帮助我们改进产品体验',
  'settings.privacy.showWorks': '作品可见性',
  'settings.privacy.showWorksDesc': '允许其他用户查看您的作品',
  'settings.privacy.allowComments': '允许评论',
  'settings.privacy.allowCommentsDesc': '允许其他用户评论您的作品',
  'settings.privacy.allowDownload': '允许下载',
  'settings.privacy.allowDownloadDesc': '允许其他用户下载您的作品',
  // Performance
  'settings.performance.title': '性能优化',
  'settings.performance.description': '调整系统性能和资源使用',
  'settings.performance.hardware': '硬件加速',
  'settings.performance.hardwareDesc': '使用 GPU 加速渲染',
  'settings.performance.preview': '预览质量',
  'settings.performance.previewDesc': '预览图像的质量级别',
  'settings.performance.autoClean': '自动清理缓存',
  'settings.performance.autoCleanDesc': '定期清理临时文件',
  'settings.performance.imageCompression': '图片压缩',
  'settings.performance.imageCompressionDesc': '自动压缩上传的图片',
  'settings.performance.lazyLoading': '懒加载',
  'settings.performance.lazyLoadingDesc': '延迟加载页面内容',
  'settings.preview.low': '低',
  'settings.preview.medium': '中',
  'settings.preview.high': '高',
  // Workflow
  'settings.workflow.title': '工作流设置',
  'settings.workflow.description': '自定义 AI 生成工作流',
  'settings.workflow.resolution': '默认分辨率',
  'settings.workflow.resolutionDesc': '图片生成的默认尺寸',
  'settings.workflow.saveHistory': '保存历史记录',
  'settings.workflow.saveHistoryDesc': '保存生成参数和提示词历史',
  'settings.workflow.autoTag': '智能标签',
  'settings.workflow.autoTagDesc': '自动为作品添加标签',
  'settings.workflow.template': '模板功能',
  'settings.workflow.templateDesc': '启用工作流模板',
  // File Management
  'settings.file.title': '文件管理',
  'settings.file.description': '管理文件存储和备份',
  'settings.file.autoBackup': '自动备份',
  'settings.file.autoBackupDesc': '自动备份重要文件',
  'settings.file.backupFrequency': '备份频率',
  'settings.file.backupFrequencyDesc': '选择备份的频率',
  'settings.file.realtime': '实时',
  'settings.file.daily': '每天',
  'settings.file.weekly': '每周',
  'settings.file.autoOrganize': '智能整理',
  'settings.file.autoOrganizeDesc': '自动分类整理文件',
  'settings.file.defaultFormat': '默认格式',
  'settings.file.defaultFormatDesc': '文件保存的默认格式',
  // Social
  'settings.social.title': '社交互动',
  'settings.social.description': '管理社交功能和互动权限',
  'settings.social.allowFollow': '允许关注',
  'settings.social.allowFollowDesc': '允许其他用户关注您',
  'settings.social.allowMessage': '允许私信',
  'settings.social.allowMessageDesc': '允许其他用户给您发私信',
  'settings.social.likeNotify': '点赞通知',
  'settings.social.likeNotifyDesc': '作品被点赞时通知',
  'settings.social.mentionNotify': '@提醒通知',
  'settings.social.mentionNotifyDesc': '被@时收到通知',
  // Security
  'settings.security.title': '账户安全',
  'settings.security.description': '增强账户安全防护',
  'settings.security.twoFactor': '双因素认证',
  'settings.security.twoFactorDesc': '增加一层安全验证',
  'settings.security.loginNotify': '登录通知',
  'settings.security.loginNotifyDesc': '新设备登录时通知',
  'settings.security.deviceVerify': '设备验证',
  'settings.security.deviceVerifyDesc': '未授权设备需要验证',
  'settings.security.autoLogout': '空闲自动登出',
  'settings.security.autoLogoutDesc': '长时间无操作自动退出',
  // Actions
  'settings.button.save': '保存设置',
  'settings.button.reset': '恢复默认',
  'settings.badge.on': '开启',
  'settings.badge.recommended': '推荐',
  // Messages
  'settings.message.saveSuccess': '设置已保存',
  'settings.message.autoSaved': '设置已自动保存',
  'settings.message.saveFailed': '保存失败，请重试',
  'settings.message.resetSuccess': '已恢复默认设置',
  'settings.autoSaveHint': '设置将自动保存',
  'settings.confirm.resetTitle': '确认重置',
  'settings.confirm.resetContent': '确定要将所有设置恢复为默认值吗？',
  'settings.confirm.reset': '重置',
  'settings.confirm.cancel': '取消',

  // Prompt Version History
  'prompt.version.label.prompt': '提示词',
  'prompt.version.label.negativePrompt': '反向提示词',
  'prompt.version.label.result': '执行结果',
}; 